import React, { useState, useEffect, useRef, useCallback } from 'react';
import { SmallInputField } from '../../../components/shareable/input';
import ArrowBox from '../../../components/shareable/arrowBox';
import { SmallDropdown } from '../../../components/shareable/dropdownMenu';
import { useDashboard } from '../../../context/dashboardContext';
import CustomModal from '../newQuote/component/customModal';
import TableComponent from '../newQuote/component/tableComponent';
import BoxComponent from '../newQuote/component/BoxComponent';
import FlipButton from '../newQuote/component/FlipButton';
import SpacerModal from '../newQuote/component/SpacerModal';
import QuoteDetailsModal from '../newQuote/component/QuoteDetailsModal';
import CreateSaw from '../saw/components/createSaw';
import { ADD_NEW_SAW_OPTION } from '../newQuote/component/SawConveyorDetails';

// Image imports
import tenFtModel from '../../../assets/images/10ft-model.jpeg';
import tenFtForkModel from '../../../assets/images/10ft-fork-model.jpg';
import liftTable from '../../../assets/images/lift-table.jpeg';
import fiveFtModel from '../../../assets/images/5ft-model.png';

import { useAuth } from '../../../context/authContext';
import toast from 'react-hot-toast';
import { Plus } from 'lucide-react';
import { useParams, useNavigate } from 'react-router-dom';
import { ATBL_ALT, LENGTH_LIMIT_MAX_FT, extractATBLDocs, pickATBLDoc, deriveModuleOptionStates } from '../../../utils/defaultValues';
import { computeGrandTotal } from '../../../utils/quoteTotals';

// PW/VR/CP are inserted as separate line items and must not modify the
// primary InFeed/OutFeed model row.
const LABEL_OPTION_LABELS = ['PW', 'VR', 'CP'];
const LABEL_OPTION_PREFIX_MAP = { PW: 'PW', VR: 'VR', CP: 'CP' };
const LABEL_OPTION_MODULE_MAP = { '10FT': '10FT', '10FTFORK': '10FTFORK', '5FT': '5FT', LFT: 'PowerLiftTable' };

const Update = () => {
  // ==============================================
  // CONTEXT & AUTHENTICATION
  // ==============================================
  const { id: quoteId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { 
    getMultipleData, 
    createQuote, 
    getSawImageData,
    getImageWithDetails,
    getModularConveyors,
    getQuoteById,
    updateQuoteVersion,
    createSaw,
  } = useDashboard();

  // ==============================================
  // STATE MANAGEMENT - UI STATE
  // ==============================================
  const [isRotatedArrow, setIsRotatedArrow] = useState(false);
  const [isRotatedBox, setIsRotatedBox] = useState(false);
  // const [isReversed, setIsReversed] = useState(false);
  const [orientation, setOrientation] = useState('left-to-right');

  const [isAddingNew, setIsAddingNew] = useState(false);
  const [items, setItems] = useState(['Infeed', 'Material Flow', 'Outfeed']);

  // ==============================================
  // STATE MANAGEMENT - MODAL STATES
  // ==============================================
  const [customModalOpen, setCustomModalOpen] = useState(false);
  const [showQuoteDetailsModal, setShowQuoteDetailsModal] = useState(false);
  const [showLengthLimitModal, setShowLengthLimitModal] = useState(false);
  const [showSpacerModal, setShowSpacerModal] = useState(false);
  const [lengthLimitMessage, setLengthLimitMessage] = useState('');
  // const [customType, setCustomType] = useState('');
  // const [customCallback, setCustomCallback] = useState(() => {});

  // ==============================================
  // STATE MANAGEMENT - DATA LISTS
  // ==============================================
  const [customers, setCustomers] = useState([]);
  const [saws, setSaws] = useState([]);
  const [showAddSaw, setShowAddSaw] = useState(false);
  const [conveyorStyles, setConveyorStyles] = useState([]);
  // const [modularConveyors, setModularConveyors] = useState([]);
  console.log(conveyorStyles);
  const [dropdownOptions, setDropdownOptions] = useState({
    rollerLengths: {
      'EX': ['48"', '58"', '70"', '82"'],
      'HD': ['24"', '30"', '36"', '42"', '48"', '60"', '72"'],
      'SG': ['24"', '30"', '36"', '42"', '48"', '60"', '72"'],
      'DEFAULT': ['24"', '30"', '36"', '42"', '48"', '60"', '72"']
    },
    conveyorStyles: [
    ]
  });

  // ==============================================
  // STATE MANAGEMENT - SELECTIONS
  // ==============================================
  const [selectedSaw, setSelectedSaw] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedCustomerName, setSelectedCustomerName] = useState('');
  const [selectedRollerLength, setSelectedRollerLength] = useState('');
  const [leftBoxRollerLength, setLeftBoxRollerLength] = useState('');
  const [rightBoxRollerLength, setRightBoxRollerLength] = useState('');
  const [selectedConveyorStyle, setSelectedConveyorStyle] = useState('');
  const [leftBoxConveyorStyle, setLeftBoxConveyorStyle] = useState('');
  const [rightBoxConveyorStyle, setRightBoxConveyorStyle] = useState('');
  

  // ==============================================
  // STATE MANAGEMENT - BOX COMPONENTS
  // ============================================== // HERE - OK
  const [leftBoxItems, setLeftBoxItems] = useState([]);
  const [rightBoxItems, setRightBoxItems] = useState([]);
  const [activeBox, setActiveBox] = useState('left'); // Track which box is currently active
  const [checkedItems, setCheckedItems] = useState({
    left: new Map(),  // Using Map for better performance
    right: new Map()
  });
  const [flippedBoxes, setFlippedBoxes] = useState({ left: false, right: false });
  // Add this state near your other state declarations
  const [filenameFlipStates, setFilenameFlipStates] = useState({
    left: false,
    right: false
  });
  const [motorSelections, setMotorSelections] = useState({
    left: null, // Will store the portionIndex of the selected MT item
    right: null // Will store the portionIndex of the selected MT item
  });
  // Add to your existing state declarations
  const [taSelections, setTASelections] = useState({
    left: {}, // Will store {portionIndex: imageUrl} for selected TA items
    right: {} // Will store {portionIndex: imageUrl} for selected TA items
  });

  const [stkSelections, setSTKSelections] = useState({
    left: {}, // Will store {portionIndex: imageUrl} for selected STK items
    right: {} // Will store {portionIndex: imageUrl} for selected STK items
  });

  // Global image cache to prevent re-fetching when items are moved between boxes
  const [globalImageCache, setGlobalImageCache] = useState(new Map());

  // Cache clear triggers for BoxComponents
  const [leftBoxCacheClear, setLeftBoxCacheClear] = useState(0);
  const [rightBoxCacheClear, setRightBoxCacheClear] = useState(0);

  const [infeedLength, setInfeedLength] = useState('');
  const [outfeedLength, setOutfeedLength] = useState('');
  const [buttonsEnabled, setButtonsEnabled] = useState({
    tenFt: false,
    tenFtFork: false,
    fiveFt: false,
    liftTable: false,
    spacer: false
  });

  // ==============================================
  // STATE MANAGEMENT - FORM DATA
  // ==============================================
  const [formFields, setFormFields] = useState({ 
    datumSide: '', 
    workBedHeight: '', 
    sawType: '',
    quotePrice: '',
    customerRFQ: '',
    standard_discount: '',
    date: '',

  });

  // ==============================================
  // STATE MANAGEMENT - QUOTE DATA
  // ==============================================
  const [isQuoteCreated, setIsQuoteCreated] = useState(false);
  const [quoteNumber, setQuoteNumber] = useState('');
  const [quoteDetails, setQuoteDetails] = useState({
    color: '',
    sawDelivery: '',
    conveyorDelivery: '',
    deliveryTerms: '',
    inspection: '',
    warranty: '',
    tax: '',
    payment: '',
    location: '',
    installation: {
      techs: '1',
      days: '1',
      laborTotal: '',
      installationTotal: '',
      showDetails: false,
      deliveryMethod: '',       // Add this
      installationOption: '',   // Add this
      installQuoted: ''         // Add this
    }
  });

  // ==============================================
  // STATE MANAGEMENT - SAMPLE DATA
  // ==============================================
  const [sampleData, setSampleData] = useState([]);

  // ==============================================
  // STATE MANAGEMENT - IMAGE DETAILS

  // ================ MT, STK, TA ====================== honay laga hun
    // State for special component images
  const [motorVariantImageUrls, setMotorVariantImageUrls] = useState({
    left: { motor: null, motor1: null, motor2: null },
    right: { motor: null, motor1: null, motor2: null }
  });
  const [taImageUrls, setTAImageUrls] = useState({
    left: { up: null, down: null },
    right: { up: null, down: null }
  });
  const [stkImageUrls, setSTKImageUrls] = useState({
    left: { high: null, low: null, high10FT: null, low10FT: null, high15FT: null, low15FT: null, high20FT: null, low20FT: null },
    right: { high: null, low: null, high10FT: null, low10FT: null, high15FT: null, low15FT: null, high20FT: null, low20FT: null }
  });
  const [motorVariantDetails, setMotorVariantDetails] = useState({
    left: { motor: null, motor1: null, motor2: null },
    right: { motor: null, motor1: null, motor2: null }
  });
  const [taDetails, setTADetails] = useState({
    left: { up: null, down: null },
    right: { up: null, down: null }
  });
  const [stkDetails, setSTKDetails] = useState({
    left: { high: null, low: null, high10FT: null, low10FT: null, high15FT: null, low15FT: null, high20FT: null, low20FT: null },
    right: { high: null, low: null, high10FT: null, low10FT: null, high15FT: null, low15FT: null, high20FT: null, low20FT: null }
  });
  

  // ==============================================
// HELPER FUNCTION TO GET ROLLER PREFIX FOR EACH BOX
// ==============================================
  const getRollerPrefixForBox = useCallback((boxName) => {
    const rollerLength = boxName === 'left' ? leftBoxRollerLength : rightBoxRollerLength;
    if (!rollerLength) return '';
    
    // Extract just the number part (remove the " symbol)
    const lengthNumber = rollerLength.replace('"', '');
    return lengthNumber + 'RL';
  }, [leftBoxRollerLength, rightBoxRollerLength]);

  // Track selected STK variant per portion per box
  const [stkVariantByPortion, setSTKVariantByPortion] = useState({ left: {}, right: {} });
  // Track selected motor variant per box (one MT per box)
  const [motorVariantByBox, setMotorVariantByBox] = useState({ left: '', right: '' });
  // Keep currently effective motor details per box for table use
  const [motorDetailsByBox, setMotorDetailsByBox] = useState({ left: null, right: null });
  const [isFlipped, setIsFlipped] = useState(false);
  // Track whether we've already used refreshQuoteData once per box
  const [usedRefreshOnce, setUsedRefreshOnce] = useState({ left: false, right: false });

// ==============================================
// MOTOR VARIANT LOADING - SEPARATE FOR EACH BOX
// ==============================================
  useEffect(() => {
    const loadMotorVariants = async () => {
      try {
        // Get roller prefix for each box
        const leftPrefix = getRollerPrefixForBox('left');
        const rightPrefix = getRollerPrefixForBox('right');
        
        // Load motor variants for left box if prefix exists
        const leftMotorVariants = leftPrefix ? await Promise.all([
          getImageWithDetails(leftPrefix + 'motor.jpg'),
          getImageWithDetails(leftPrefix + 'motor1.jpg'),
          getImageWithDetails(leftPrefix + 'motor2.jpg')
        ]) : [null, null, null];

        // Load motor variants for right box if prefix exists and is different from left
        const rightMotorVariants = rightPrefix && rightPrefix !== leftPrefix ? await Promise.all([
          getImageWithDetails(rightPrefix + 'motor.jpg'),
          getImageWithDetails(rightPrefix + 'motor1.jpg'),
          getImageWithDetails(rightPrefix + 'motor2.jpg')
        ]) : leftMotorVariants;

        setMotorVariantImageUrls(prev => ({
          left: {
            motor: leftMotorVariants[0]?.url || null,
            motor1: leftMotorVariants[1]?.url || null,
            motor2: leftMotorVariants[2]?.url || null
          },
          right: {
            motor: rightMotorVariants[0]?.url || null,
            motor1: rightMotorVariants[1]?.url || null,
            motor2: rightMotorVariants[2]?.url || null
          }
        }));

        setMotorVariantDetails(prev => ({
          left: {
            motor: leftMotorVariants[0]?.conveyorData || null,
            motor1: leftMotorVariants[1]?.conveyorData || null,
            motor2: leftMotorVariants[2]?.conveyorData || null
          },
          right: {
            motor: rightMotorVariants[0]?.conveyorData || null,
            motor1: rightMotorVariants[1]?.conveyorData || null,
            motor2: rightMotorVariants[2]?.conveyorData || null
          }
        }));

        // Initialize per-box details
        setMotorDetailsByBox(prev => ({
          left: prev.left ?? (motorSelections.left != null ? leftMotorVariants[0]?.conveyorData : null),
          right: prev.right ?? (motorSelections.right != null ? rightMotorVariants[0]?.conveyorData : null)
        }));
      } catch (error) {
        console.error('Error loading motor variants:', error);
      }
    };
    
    loadMotorVariants();
  }, [getImageWithDetails, motorSelections.left, motorSelections.right, getRollerPrefixForBox]);

  // When the selected variant changes, update table details per box
// When the selected variant changes, update table details per box
useEffect(() => {
  setMotorDetailsByBox(prev => ({
    left: motorSelections.left != null ? motorVariantDetails.left?.[motorVariantByBox.left] || null : null,
    right: motorSelections.right != null ? motorVariantDetails.right?.[motorVariantByBox.right] || null : null
  }));
}, [motorVariantByBox, motorSelections, motorVariantDetails]);



  const getSpecialLabelFilename = useCallback(
  (label, boxName, portionIndex) => {
    switch (label) {
      case "MT":
        // Use per-box roller-length prefix and selected motor variant
        {
          const prefix = getRollerPrefixForBox(boxName);
          const variant = motorVariantByBox?.[boxName] || 'motor';
          return `${prefix}${variant}.jpg`;
        }
      case "TA":
        // Use per-box roller-length prefix for TA filenames
        {
          const prefix = getRollerPrefixForBox(boxName);
          return filenameFlipStates[boxName]
            ? `${prefix}TADown.jpg`
            : `${prefix}TAUp.jpg`;
        }
      case "STK":
        // STK images are universal — same filenames regardless of roller length or conveyor style
        {
          const stkVariant = stkVariantByPortion?.[boxName]?.[portionIndex] || '5FT';
          const stkSize = stkVariant.replace('FT', '');
          const stkHeight = filenameFlipStates[boxName] ? 'LOW' : 'HIGH';
          return `BABS-${stkSize}-STKA-BO-${stkHeight}.jpg`;
        }
      default:
        return "";
    }
  },
  [filenameFlipStates, getRollerPrefixForBox, motorVariantByBox, stkVariantByPortion] // dependency
);
  // Helper functions for quote management
const addSpecialLabelToQuote = useCallback(
  async (boxName, label, details = null, index) => {
    try {
      console.log(`🔍 Adding special label ${label} to quote for ${boxName} box, portion ${index}`);

      let conveyorData = details;

      // If details weren't provided, fetch them
      if (!conveyorData) {
        console.log(`🔍 Fetching details for special label ${label}`);
        const filename = getSpecialLabelFilename(label, boxName, index);
        const response = await getImageWithDetails(filename);
        conveyorData = response.conveyorData;
      }

      if (conveyorData) {
        setSampleData((prev) => {
          // For STK/TA labels, filter by boxName, specialLabel AND portionIndex
          // For other labels (MT), keep the old behavior (single entry per box)
          const isPortionScopedLabel = label === 'STK' || label === 'TA';
          let filtered;
          if (isPortionScopedLabel) {
            filtered = prev.filter((item) => !(
              item.boxName === boxName &&
              item.specialLabel === label &&
              item.portionIndex === index
            ));
          } else {
            // For MT, keep only one entry per box
            filtered = prev.filter((item) => !(item.boxName === boxName && item.specialLabel === label));
          }

          // Add new entry with quantity ALWAYS 1
          const newItem = {
            id: Date.now() + Math.random(),
            partName: conveyorData.part_number || `${label} Component`,
            partNumber: conveyorData.part_number || label,
            description: conveyorData.conveyor_name || `${label} Component`,
            boxName,
            boxType: boxName === "left" ? "Infeed" : "Outfeed",
            portionIndex: isPortionScopedLabel ? index : "special",
            qty: 1, // ALWAYS quantity 1, never more
            listPrice: conveyorData.list || 0,
            discount: 0,
            actualPrice: conveyorData.list || 0,
            isNew: false,
            isEditing: false,
            imageName: getSpecialLabelFilename(label, boxName, index),
            specialLabel: label,
            motorIndex: index || 'special'
          };

          return [...filtered, newItem];
        });

        console.log(`✅ Added ${label} component to quote`);
      }
    } catch (error) {
      console.error(`Error fetching details for ${label} component:`, error);
    }
  },
  [setSampleData, getSpecialLabelFilename, getImageWithDetails] // dependencies
);

const removeSpecialLabelFromQuote = useCallback((boxName, label, portionIndex = null) => {
  setSampleData(prev => {
    const isPortionScopedLabel = (label === 'STK' || label === 'TA') && portionIndex !== null;
    if (isPortionScopedLabel) {
      const targetPortion = String(portionIndex);
      return prev.filter(item => !(
        item.boxName === boxName &&
        item.specialLabel === label &&
        String(item.portionIndex) === targetPortion
      ));
    }
    // For other labels or when no portionIndex provided, remove all instances for that box
    return prev.filter(item => !(item.boxName === boxName && item.specialLabel === label));
  });
  console.log(`❌ Removed ${label} component from quote`);
}, [setSampleData]);

// ==============================================
// LABEL-OPTION ROWS (PW / VR / CP)
// PW/VR/CP must NOT modify the InFeed/OutFeed primary model row — they are
// inserted as separate line items, mirroring the create-quote flow.
// ==============================================
const buildLabelOptionImageNames = useCallback((label, moduleAlt, boxName) => {
  const labelCode = LABEL_OPTION_PREFIX_MAP[label] || label;
  const moduleCode = LABEL_OPTION_MODULE_MAP[moduleAlt] || moduleAlt;
  if (!labelCode || !moduleCode) return [];
  const rollerSuffix = labelCode === 'CP' ? getRollerPrefixForBox(boxName) : '';
  const base = `${labelCode}${moduleCode}${rollerSuffix || ''}`;
  return [`${base}.jpg`];
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [getRollerPrefixForBox]);

const upsertLabelOptionRow = useCallback(async (boxName, portionIndex, label, isChecked) => {
  const currentItems = boxName === 'left' ? leftBoxItems : rightBoxItems;
  const module = currentItems?.[portionIndex];
  if (!module) return;

  const portionKey = String(portionIndex);
  const labelCode = LABEL_OPTION_PREFIX_MAP[label] || label;
  const moduleCode = LABEL_OPTION_MODULE_MAP[module?.alt] || module?.alt;
  const optionKey = `${boxName}-${portionKey}-${labelCode}`;

  if (!isChecked) {
    setSampleData((prev) => prev.map((item) => {
      if (item.labelOptionKeys && item.labelOptionKeys.includes(optionKey)) {
        const updatedKeys = item.labelOptionKeys.filter((key) => key !== optionKey);
        const updatedPortions = item.portionIndices?.filter((idx) => idx !== portionKey) || [];
        if (updatedKeys.length === 0) return null;
        const newQty = Math.max(0, (parseFloat(item.qty) || 0) - 1);
        const newExtPrice = newQty * (item.actualPrice || 0);
        return {
          ...item,
          labelOptionKeys: updatedKeys,
          labelOptionKey: updatedKeys[0],
          portionIndices: updatedPortions,
          portionIndex: updatedPortions[0] || item.portionIndex,
          qty: newQty,
          extPrice: newExtPrice
        };
      }
      if (item.labelOptionKey === optionKey) return null;
      return item;
    }).filter(Boolean));
    return;
  }

  const candidates = buildLabelOptionImageNames(label, module?.alt, boxName);
  let conveyorData = null;
  let usedImageName = null;
  for (const name of candidates) {
    if (!name) continue;
    try {
      const res = await getImageWithDetails(name);
      if (res?.conveyorData) {
        conveyorData = res.conveyorData;
        usedImageName = name;
        break;
      }
    } catch (error) {
      console.error(`Error fetching label option data for ${name}:`, error);
    }
  }
  if (!conveyorData) return;

  const qty = 1;
  const listPrice = Number(conveyorData.list ?? conveyorData.total ?? 0) || 0;
  const actualPrice = listPrice;
  const partName = conveyorData.part_number || `${labelCode}${moduleCode}`;
  const partNumber = conveyorData.part_number || `${labelCode}${moduleCode}`;
  const description = conveyorData.conveyor_name || conveyorData.module_description || `${labelCode} ${moduleCode}`;

  setSampleData((prev) => {
    const filtered = prev.filter((item) => item.labelOptionKey !== optionKey);
    const existingItemIndex = filtered.findIndex(
      (item) => item.partName === partName && item.specialLabel === labelCode && item.boxName === boxName && item.labelOptionKey
    );
    if (existingItemIndex !== -1) {
      const existingItem = filtered[existingItemIndex];
      const newQty = (parseFloat(existingItem.qty) || 0) + qty;
      const newExtPrice = newQty * actualPrice;
      const portionIndices = existingItem.portionIndices || [existingItem.portionIndex];
      if (!portionIndices.includes(portionKey)) portionIndices.push(portionKey);
      const labelOptionKeys = existingItem.labelOptionKeys || [existingItem.labelOptionKey];
      if (!labelOptionKeys.includes(optionKey)) labelOptionKeys.push(optionKey);
      filtered[existingItemIndex] = {
        ...existingItem,
        qty: newQty,
        extPrice: newExtPrice,
        portionIndices,
        labelOptionKeys,
        portionIndex: portionIndices[0]
      };
      return filtered;
    }
    return [...filtered, {
      id: Date.now() + Math.random(),
      labelOptionKey: optionKey,
      labelOptionKeys: [optionKey],
      partName,
      partNumber,
      description,
      boxName,
      boxType: boxName === 'left' ? 'Infeed' : 'Outfeed',
      portionIndex: portionKey,
      portionIndices: [portionKey],
      qty,
      listPrice,
      discount: 0,
      actualPrice,
      extPrice: qty * actualPrice,
      isNew: false,
      isEditing: false,
      imageName: usedImageName,
      specialLabel: labelCode,
      moduleType: moduleCode
    }];
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [buildLabelOptionImageNames, getImageWithDetails, leftBoxItems, rightBoxItems, setSampleData]);

// Handle selecting a motor variant for a portion in a box
const handleMotorSelect = useCallback((boxName, portionIndex, variant) => {
  setMotorVariantByBox(prev => ({ ...prev, [boxName]: variant }));

  if (!variant) {
    // Clear selection if user chooses blank
    setMotorSelections(prev => ({ ...prev, [boxName]: null }));
    setCheckedItems(prev => {
      const next = { left: new Map(prev.left), right: new Map(prev.right) };
      const map = new Map(next[boxName]);
      Array.from(map.keys()).forEach(key => {
        if (/-MT$/.test(key)) {
          map.delete(key);
        }
      });
      next[boxName] = map;
      return next;
    });
    setMotorDetailsByBox(prev => ({ ...prev, [boxName]: null }));
    // Remove MT entry from quote table if present
    removeSpecialLabelFromQuote(boxName, 'MT');
    return;
  }

  // Set the selected portion for MT and sync checked state
  setMotorSelections(prev => ({ ...prev, [boxName]: portionIndex }));
  setCheckedItems(prev => {
    const next = { left: new Map(prev.left), right: new Map(prev.right) };
    const map = new Map(next[boxName]);
    Array.from(map.keys()).forEach(key => {
      if (/-MT$/.test(key)) {
        map.delete(key);
      }
    });
    map.set(`${portionIndex}-MT`, true);
    next[boxName] = map;
    return next;
  });
  
  // FIXED: Access motor variant details by box name first
  const motorDetails = motorVariantDetails[boxName]?.[variant] || null;
  setMotorDetailsByBox(prev => ({ ...prev, [boxName]: motorDetails }));

  // Immediately add the motor to the quote with the selected variant details
  if (motorDetails) {
    // First remove any existing motor entry for this box
    removeSpecialLabelFromQuote(boxName, 'MT');
    
    // Then add the new motor entry
    addSpecialLabelToQuote(boxName, 'MT', motorDetails);
  }
}, [motorVariantDetails, addSpecialLabelToQuote, removeSpecialLabelFromQuote]);

// ==============================================
// TA IMAGE LOADING - SEPARATE FOR EACH BOX
// ==============================================
  useEffect(() => {
    const loadTAImages = async () => {
      try {
        const leftPrefix = getRollerPrefixForBox('left');
        const rightPrefix = getRollerPrefixForBox('right');
        
        // Load TA images for left box if prefix exists
        const leftTAImages = leftPrefix ? await Promise.all([
          getImageWithDetails(leftPrefix + 'TAUp.jpg'),
          getImageWithDetails(leftPrefix + 'TADown.jpg')
        ]) : [null, null];

        // Load TA images for right box if prefix exists and is different from left
        const rightTAImages = rightPrefix && rightPrefix !== leftPrefix ? await Promise.all([
          getImageWithDetails(rightPrefix + 'TAUp.jpg'),
          getImageWithDetails(rightPrefix + 'TADown.jpg')
        ]) : leftTAImages;

        setTAImageUrls(prev => ({
          left: {
            up: leftTAImages[0]?.url || null,
            down: leftTAImages[1]?.url || null
          },
          right: {
            up: rightTAImages[0]?.url || null,
            down: rightTAImages[1]?.url || null
          }
        }));

        setTADetails(prev => ({
          left: {
            up: leftTAImages[0]?.conveyorData || null,
            down: leftTAImages[1]?.conveyorData || null
          },
          right: {
            up: rightTAImages[0]?.conveyorData || null,
            down: rightTAImages[1]?.conveyorData || null
          }
        }));
      } catch (error) {
        console.error('Error loading TA images:', error);
      }
    };
    
    loadTAImages();
  }, [getImageWithDetails, getRollerPrefixForBox]);

// ==============================================
// STK IMAGE LOADING - SEPARATE FOR EACH BOX
// ==============================================
  useEffect(() => {
    const loadSTKImages = async () => {
      try {
        const leftPrefix = getRollerPrefixForBox('left');
        const rightPrefix = getRollerPrefixForBox('right');
        
        // STK images are universal — same filenames regardless of roller length or conveyor style
        const stkImages = await Promise.all([
          getImageWithDetails('BABS-5-STKA-BO-HIGH.jpg'),
          getImageWithDetails('BABS-5-STKA-BO-LOW.jpg'),
          getImageWithDetails('BABS-10-STKA-BO-HIGH.jpg'),
          getImageWithDetails('BABS-10-STKA-BO-LOW.jpg'),
          getImageWithDetails('BABS-15-STKA-BO-HIGH.jpg'),
          getImageWithDetails('BABS-15-STKA-BO-LOW.jpg'),
          getImageWithDetails('BABS-20-STKA-BO-HIGH.jpg'),
          getImageWithDetails('BABS-20-STKA-BO-LOW.jpg')
        ]);

        const stkUrlData = {
          high: stkImages[0]?.url || null, low: stkImages[1]?.url || null,
          high10FT: stkImages[2]?.url || null, low10FT: stkImages[3]?.url || null,
          high15FT: stkImages[4]?.url || null, low15FT: stkImages[5]?.url || null,
          high20FT: stkImages[6]?.url || null, low20FT: stkImages[7]?.url || null
        };
        const stkDetData = {
          high: stkImages[0]?.conveyorData || null, low: stkImages[1]?.conveyorData || null,
          high10FT: stkImages[2]?.conveyorData || null, low10FT: stkImages[3]?.conveyorData || null,
          high15FT: stkImages[4]?.conveyorData || null, low15FT: stkImages[5]?.conveyorData || null,
          high20FT: stkImages[6]?.conveyorData || null, low20FT: stkImages[7]?.conveyorData || null
        };
        setSTKImageUrls({ left: stkUrlData, right: stkUrlData });
        setSTKDetails({ left: stkDetData, right: stkDetData });
      } catch (error) {
        console.error('Error loading STK images:', error);
      }
    };
    
    loadSTKImages();
  }, [getImageWithDetails, getRollerPrefixForBox]);

    const [sawImage, setSawImage] = useState(null);

  useEffect(() => {
    const fetchSawDetailsAndImage = async () => {
      // Only fetch if a saw is selected and has an image name
      if (selectedSaw && selectedSaw.image_name) {
        try {
          // Fetch both saw details and image from the API
          const result = await getSawImageData(selectedSaw.image_name);

          if (result.success) {
            // Set the image URL
            setSawImage(result.url);
            
            // Update the selected saw with detailed information from the API
            if (result.sawDetails) {
              setSelectedSaw(prev => ({
                ...prev,
                ...result.sawDetails
              }));
              
              // Update form fields with the detailed information
              setFormFields(prev => ({
                ...prev,
                datumSide: result.sawDetails.datum_side || '',
                workBedHeight: result.sawDetails.work_bed_height?.toString() || '',
                sawType: result.sawDetails.saw_type || ''
              }));
            }
          } else {
            console.error("Failed to fetch saw details:", result.error);
            setSawImage(null);
          }
        } catch (error) {
          console.error("Error fetching saw details:", error);
          setSawImage(null);
        }
      } else {
        setSawImage(null); // Clear image when no saw is selected
      }
    };

    fetchSawDetailsAndImage();
  }, [selectedSaw, getSawImageData]);

  // ==============================================
// EFFECT TO RELOAD SPECIAL IMAGES WHEN ROLLER LENGTH CHANGES
// ==============================================
useEffect(() => {
  const reloadImages = async () => {
    try {
      const leftPrefix = getRollerPrefixForBox('left');
      const rightPrefix = getRollerPrefixForBox('right');
      
      // Reload motor variants for left box
      if (leftPrefix) {
        const [m0, m1, m2] = await Promise.all([
          getImageWithDetails(leftPrefix + 'motor.jpg'),
          getImageWithDetails(leftPrefix + 'motor1.jpg'),
          getImageWithDetails(leftPrefix + 'motor2.jpg')
        ]);
        
        setMotorVariantImageUrls(prev => ({
          ...prev,
          left: {
            motor: m0?.url || null,
            motor1: m1?.url || null,
            motor2: m2?.url || null
          }
        }));
        
        setMotorVariantDetails(prev => ({
          ...prev,
          left: {
            motor: m0?.conveyorData || null,
            motor1: m1?.conveyorData || null,
            motor2: m2?.conveyorData || null
          }
        }));
      }
      
      // Reload motor variants for right box (if different prefix)
      if (rightPrefix && rightPrefix !== leftPrefix) {
        const [m0, m1, m2] = await Promise.all([
          getImageWithDetails(rightPrefix + 'motor.jpg'),
          getImageWithDetails(rightPrefix + 'motor1.jpg'),
          getImageWithDetails(rightPrefix + 'motor2.jpg')
        ]);
        
        setMotorVariantImageUrls(prev => ({
          ...prev,
          right: {
            motor: m0?.url || null,
            motor1: m1?.url || null,
            motor2: m2?.url || null
          }
        }));
        
        setMotorVariantDetails(prev => ({
          ...prev,
          right: {
            motor: m0?.conveyorData || null,
            motor1: m1?.conveyorData || null,
            motor2: m2?.conveyorData || null
          }
        }));
      }
      
      // Reload TA images for left box
      if (leftPrefix) {
        const [taUp, taDown] = await Promise.all([
          getImageWithDetails(leftPrefix + 'TAUp.jpg'),
          getImageWithDetails(leftPrefix + 'TADown.jpg')
        ]);
        
        setTAImageUrls(prev => ({
          ...prev,
          left: {
            up: taUp?.url || null,
            down: taDown?.url || null
          }
        }));
        
        setTADetails(prev => ({
          ...prev,
          left: {
            up: taUp?.conveyorData || null,
            down: taDown?.conveyorData || null
          }
        }));
      }
      
      // Reload TA images for right box (if different prefix)
      if (rightPrefix && rightPrefix !== leftPrefix) {
        const [taUp, taDown] = await Promise.all([
          getImageWithDetails(rightPrefix + 'TAUp.jpg'),
          getImageWithDetails(rightPrefix + 'TADown.jpg')
        ]);
        
        setTAImageUrls(prev => ({
          ...prev,
          right: {
            up: taUp?.url || null,
            down: taDown?.url || null
          }
        }));
        
        setTADetails(prev => ({
          ...prev,
          right: {
            up: taUp?.conveyorData || null,
            down: taDown?.conveyorData || null
          }
        }));
      }
      
      // STK images are universal — reload with fixed filenames
      {
        const [stkHigh, stkLow, stkHigh10FT, stkLow10FT, stkHigh15FT, stkLow15FT, stkHigh20FT, stkLow20FT] = await Promise.all([
          getImageWithDetails('BABS-5-STKA-BO-HIGH.jpg'),
          getImageWithDetails('BABS-5-STKA-BO-LOW.jpg'),
          getImageWithDetails('BABS-10-STKA-BO-HIGH.jpg'),
          getImageWithDetails('BABS-10-STKA-BO-LOW.jpg'),
          getImageWithDetails('BABS-15-STKA-BO-HIGH.jpg'),
          getImageWithDetails('BABS-15-STKA-BO-LOW.jpg'),
          getImageWithDetails('BABS-20-STKA-BO-HIGH.jpg'),
          getImageWithDetails('BABS-20-STKA-BO-LOW.jpg')
        ]);
        const stkUrlData = { high: stkHigh?.url || null, low: stkLow?.url || null, high10FT: stkHigh10FT?.url || null, low10FT: stkLow10FT?.url || null, high15FT: stkHigh15FT?.url || null, low15FT: stkLow15FT?.url || null, high20FT: stkHigh20FT?.url || null, low20FT: stkLow20FT?.url || null };
        const stkDetData = { high: stkHigh?.conveyorData || null, low: stkLow?.conveyorData || null, high10FT: stkHigh10FT?.conveyorData || null, low10FT: stkLow10FT?.conveyorData || null, high15FT: stkHigh15FT?.conveyorData || null, low15FT: stkLow15FT?.conveyorData || null, high20FT: stkHigh20FT?.conveyorData || null, low20FT: stkLow20FT?.conveyorData || null };
        setSTKImageUrls({ left: stkUrlData, right: stkUrlData });
        setSTKDetails({ left: stkDetData, right: stkDetData });
      }
      
    } catch (error) {
      console.error('Error reloading images:', error);
    }
  };
  
  if (leftBoxRollerLength || rightBoxRollerLength) {
    reloadImages();
  } else {
    // Clear images if no roller length is selected
    setMotorVariantImageUrls({ 
      left: { motor: null, motor1: null, motor2: null }, 
      right: { motor: null, motor1: null, motor2: null } 
    });
    
    setTAImageUrls({ 
      left: { up: null, down: null }, 
      right: { up: null, down: null } 
    });
    
    setSTKImageUrls({ 
      left: { high: null, low: null }, 
      right: { high: null, low: null } 
    });
    
    // Also clear details
    setMotorVariantDetails({ 
      left: { motor: null, motor1: null, motor2: null }, 
      right: { motor: null, motor1: null, motor2: null } 
    });
    
    setTADetails({ 
      left: { up: null, down: null }, 
      right: { up: null, down: null } 
    });
    
    setSTKDetails({ 
      left: { high: null, low: null }, 
      right: { high: null, low: null } 
    });
  }
}, [leftBoxRollerLength, rightBoxRollerLength, getRollerPrefixForBox, getImageWithDetails]);
  // ==============================================
  // IMAGE WITH DETAILS + CALLING API FROM PARENT
  // ==============================================

  // Cache of the four BABS-8-ATBL-30-* docs grouped by side + flip slot.
  const atblDocsRef = useRef({ leftDefault: null, leftFlipped: null, rightDefault: null, rightFlipped: null });

  // Per-box counter of expected flip-induced refetches. While > 0 for a box,
  // addOrUpdateConveyorItem MUST NOT mutate sampleData for that box —
  // user expects "do flip" to leave quote-details rows (qty/discount/desc edits) untouched.
  const flipSuppressRef = useRef({ left: 0, right: 0 });

  // Quote-load line-item replay: fetchQuoteData stashes the loaded quote
  // here, and a follow-up effect runs the PW/VR/CP/MT/TA/STK label handlers
  // AFTER leftBoxItems/rightBoxItems have been committed.
  const pendingQuoteReplayRef = useRef(null);

  const getATBLImageName = useCallback((boxName, isFlipped) => {
    const doc = pickATBLDoc(atblDocsRef.current, boxName, isFlipped);
    return doc?.image_name || '';
  }, []);

  const generateConveyorFilename = useCallback((selectedLabels, itemType, conveyorStyle, boxName, opts = {}) => {
    if (itemType === ATBL_ALT) {
      return getATBLImageName(boxName, !!filenameFlipStates[boxName]);
    }
    if (!conveyorStyle) return '';

    if (itemType.startsWith('SP-')) return 'SPACER.jpg';

    let prefix = '';
    const styleValue = typeof conveyorStyle === 'string' 
      ? conveyorStyle 
      : conveyorStyle.value || '';
    const styleUpper = styleValue.toUpperCase();

    console.log('🔍 Style analysis:', {
      originalStyle: conveyorStyle,
      styleValue: styleValue,
      styleUpper: styleUpper,
      isEX: styleUpper.includes('EX') || styleUpper.includes('EXTREME'),
      isSG: styleUpper.includes('SG') || styleUpper.includes('SIGMA'),
      isHD: styleUpper.includes('HD') || styleUpper.includes('HEAVY DUTY')
    });

    // Determine prefix based on style
    if (styleUpper.includes('EX') || styleUpper.includes('EXTREME')) {
      prefix = 'EX';
    } else if (styleUpper.includes('SG') || styleUpper.includes('SIGMA')) {
      prefix = 'SG';
    } else if (styleUpper.includes('HD') || styleUpper.includes('HEAVY DUTY')) {
      prefix = ''; // HD style has no prefix
    } else {
      // For all other styles, use first letter uppercase
      prefix = styleValue.charAt(0).toUpperCase();
    }

    // Add roller length to prefix if selected (per-box roller length)
    const rollerLength = boxName === 'left' ? leftBoxRollerLength : rightBoxRollerLength;
    if (rollerLength) {
      // Extract just the number part (remove the " symbol)
      const lengthNumber = rollerLength.replace('"', '');
      prefix = `${prefix}${lengthNumber}RL`;
    }

    const labelMapping = { PW: 'PW', VR: 'VR', CP: 'CP' };
    let labelsPart = '';

    // For LFT (Lift Table / LTOPTION), always compute from selections for all styles
    if (itemType === 'LFT') {
      const conveyorLabels = ['PW', 'VR', 'CP'];
      labelsPart = conveyorLabels
        .map(label => (selectedLabels.includes(label) ? labelMapping[label] : `N${labelMapping[label]}`))
        .join('');
    } else if (styleUpper.includes('EX') || styleUpper.includes('EXTREME')) {
      labelsPart = 'PWNVRCP';
    } else if (styleUpper.includes('SG') || styleUpper.includes('SIGMA')) {
      labelsPart = 'PWNVRNCP';
    } else {
      // For HD and all other styles
      const conveyorLabels = ['PW', 'VR', 'CP'];
      labelsPart = conveyorLabels
        .map(label => (selectedLabels.includes(label) ? labelMapping[label] : `N${labelMapping[label]}`))
        .join('');
    }

    const modelMap = {
      '5FT': '5FT',
      '10FT': '10FT',
      '10FTFORK': '10FTFORK',
      'LFT': 'LTOPTION'
    };
    let modelPart = modelMap[itemType] || '5FT';

    // Only 5FT changes filename on user-flip (other modules flip via CSS
    // scaleY(-1) in BoxComponent and keep a stable backend filename). The
    // suffix is appended only when the user has actually flipped the box;
    // the un-suffixed name is the canonical S3 default for 5FT. The earlier
    // "FLIP record is the canonical default" inversion broke HD-style 5FT
    // + CP because S3 has 24RLNPWNVRCP5FT.jpg but not the 5FTD variant.
    const isFiveFt = itemType === '5FT';
    let orientationSuffix = '';
    if (isFiveFt && !!filenameFlipStates[boxName]) {
      if (styleUpper.includes('EX') || styleUpper.includes('EXTREME') ||
          styleUpper.includes('SG') || styleUpper.includes('SIGMA')) {
        orientationSuffix = 'FLIP';
      } else if (styleUpper.includes('HD') || styleUpper.includes('HEAVY DUTY')) {
        orientationSuffix = 'D';
      } else {
        orientationSuffix = 'FLIP';
      }
    }

    const finalFilename = `${prefix}${labelsPart}${modelPart}${orientationSuffix}.jpg`;
    console.log("✅ Final Conveyor Filename:", finalFilename, "Box:", boxName, "isFlipped:", filenameFlipStates[boxName], "Selected Labels:", selectedLabels);
    console.log("📋 Filename breakdown:", {
      prefix,
      labelsPart,
      modelPart,
      orientationSuffix,
      finalFilename,
      itemType,
      styleUpper,
      isSigma: styleUpper.includes('SG') || styleUpper.includes('SIGMA'),
      isExtreme: styleUpper.includes('EX') || styleUpper.includes('EXTREME'),
      isHeavyDuty: styleUpper.includes('HD') || styleUpper.includes('HEAVY DUTY')
    });
    return finalFilename;
  }, [filenameFlipStates, leftBoxRollerLength, rightBoxRollerLength, getATBLImageName]);
// ==============================================
// IMAGE LOADING FUNCTION - MOVED TO PARENT
// ==============================================
// 1. addOrUpdateConveyorItem - Updated to handle specific image replacement
const addOrUpdateConveyorItem = (conveyorData, boxName, portionIndex, isReplacement = false, knownFilename = null) => {
  if (!conveyorData || !conveyorData.part_number) return;

  // While a flip refetch for this box is in progress, skip the sampleData
  // rebuild so user edits (qty/discount/description/manualQty) survive.
  // URL caching happens in getImageForSelection independent of this path,
  // so the diagram still updates with the flipped image.
  if (flipSuppressRef.current[boxName] > 0) {
    flipSuppressRef.current[boxName] -= 1;
    return;
  }

  // Get the current items for this box
  const currentItems = boxName === 'left' ? leftBoxItems : rightBoxItems;

  if (!currentItems || Object.keys(currentItems).length === 0) return;

  // Generate image names for all items in the box
  const imageNames = [];
  const filenameGroups = {};
  
  // Process each item in the box
  Object.keys(currentItems).forEach(portionIdx => {
    const item = currentItems[portionIdx];
    if (!item || item.type !== 'option') return;

    // Generate filename for this item based on current checkbox states
    const selectedLabels = item.labels.filter(l => {
      const key = `${portionIdx}-${l}`;
      return checkedItems[boxName].get(key) === true;
    });

    const filename = generateConveyorFilename(
      selectedLabels,
      item.alt,
      boxName === 'left' ? leftBoxConveyorStyle : rightBoxConveyorStyle,
      boxName
    );

    // PW must flow into the primary filename so the backend resolves the
    // powered variant (e.g. BABS-10-P-24) instead of the non-powered variant
    // (BABS-10-NP-24). VR/CP are still excluded — they remain pure add-on
    // line items via upsertLabelOptionRow and must not change the primary row.
    const primaryLabels = selectedLabels.filter(l => l !== 'VR' && l !== 'CP');
    const primaryFilename = generateConveyorFilename(
      primaryLabels,
      item.alt,
      boxName === 'left' ? leftBoxConveyorStyle : rightBoxConveyorStyle,
      boxName,
      { swapFiveFt: false }
    );
    const groupKey = item.alt.startsWith('SP-')
      ? `SPACER-${item.width || item.alt.split('-')[1]}FT.jpg`
      : primaryFilename;
    if (!filenameGroups[groupKey]) {
      filenameGroups[groupKey] = {
        portions: [],
        item: item,
        selectedLabels: selectedLabels,
        actualFilename: filename
      };
    }
    filenameGroups[groupKey].portions.push(portionIdx);
    // Fetch primary (no PW/VR/CP) filename for non-spacers; spacers always
    // resolve to 'SPACER.jpg'.
    imageNames.push(item.alt.startsWith('SP-') ? filename : primaryFilename);
  });

  // Prepare known details to avoid duplicate fetch for the just-fetched filename
  const knownDetails = {};
  if (knownFilename) {
    knownDetails[knownFilename] = conveyorData;
  }

  // Fetch conveyor details for all unique image names
  fetchConveyorDetailsForImages(imageNames, boxName, filenameGroups, knownDetails);
};

// 2. getImageForSelection - Updated to pass portionIndex for replacement logic
const getImageForSelection = async (item, portionIndex, boxName, checkedItems, isReplacement = false) => {
  if (!item || item.type !== 'option') return null;
  
  // If the item already has an imageUrl (like loaded images), use it directly
  if (item.imageUrl) {
    console.log('✅ Using direct imageUrl from item:', item.imageUrl);
    return item.imageUrl;
  }
  
  const imageKey = getImageKey(item, portionIndex, boxName, checkedItems);
  
  // Check global cache first for IMAGE URL only
  if (globalImageCache.has(imageKey)) {
    console.log('✅ Using global cached image for:', imageKey);
    
    // BUT we still need to fetch the conveyor data if this is a new selection
    // Fetch conveyor data separately without using the cached image
    await fetchConveyorDataForItem(item, portionIndex, boxName, checkedItems, isReplacement);
    
    return globalImageCache.get(imageKey);
  }
  
  // Handle spacer items
  if (item.alt.startsWith('SP-')) {
    try {
      console.log('🌐 Fetching SPACER.jpg image from API');
      const imageResponse = await getImageWithDetails('SPACER.jpg');
      console.log(imageResponse);
      
      if (imageResponse.conveyorData) {
        addOrUpdateConveyorItem(imageResponse.conveyorData, boxName, portionIndex, isReplacement);
      }
      
      if (imageResponse?.url) {
        console.log('✅ Successfully got SPACER.jpg image URL');
        const url = imageResponse.url;
        setGlobalImageCache(prev => new Map(prev).set(imageKey, url));
        return url;
      }
    } catch (error) {
      console.error('❌ Error loading SPACER.jpg image:', error);
      try {
        console.log('🔄 Trying fallback: SPACER without extension');
        const fallbackResponse = await getImageWithDetails('SPACER');
        
        if (fallbackResponse.conveyorData) {
          addOrUpdateConveyorItem(fallbackResponse.conveyorData, boxName, portionIndex, isReplacement);
        }
        
        if (fallbackResponse?.url) {
          console.log('✅ Successfully got fallback SPACER image URL');
          const url = fallbackResponse.url;
          setGlobalImageCache(prev => new Map(prev).set(imageKey, url));
          return url;
        }
      } catch (fallbackError) {
        console.error('❌ Error loading fallback SPACER image:', fallbackError);
      }
    }
    return null;
  }

  // Regular conveyor items
  const selectedLabels = item.labels.filter(label => { 
    const key = `${portionIndex}-${label}`; 
    return checkedItems.get(key) === true;
  });
  
  const filename = generateConveyorFilename(
    selectedLabels, 
    item.alt, 
    boxName === 'left' ? leftBoxConveyorStyle : rightBoxConveyorStyle, 
    boxName
  );

  console.log('🔍 Regular item filename:', filename);

  try {
    const imageResponse = await getImageWithDetails(filename);
    
    if (imageResponse.conveyorData) {
      // Pass known filename to prevent duplicate fetch in batch updater
      addOrUpdateConveyorItem(imageResponse.conveyorData, boxName, portionIndex, isReplacement, filename);
    }
    
    if (imageResponse?.url) {
      const url = imageResponse.url;
      setGlobalImageCache(prev => new Map(prev).set(imageKey, url));
      return url;
    }
  } catch (error) {
    console.error('Error loading image with generated filename:', filename, error);
  }

  return null;
};

// 3. fetchConveyorDataForItem - Updated to handle replacement logic
const fetchConveyorDataForItem = async (item, portionIndex, boxName, checkedItems, isReplacement = false) => {
  if (item.alt.startsWith('SP-')) {
    try {
      const imageResponse = await getImageWithDetails('SPACER.jpg');
      if (imageResponse.conveyorData) {
        addOrUpdateConveyorItem(imageResponse.conveyorData, boxName, portionIndex, isReplacement);
      }
    } catch (error) {
      console.error('Error fetching spacer conveyor data:', error);
    }
    return;
  }

  const selectedLabels = item.labels.filter(label => { 
    const key = `${portionIndex}-${label}`; 
    return checkedItems.get(key) === true;
  });
  
  const filename = generateConveyorFilename(
    selectedLabels, 
    item.alt, 
    boxName === 'left' ? leftBoxConveyorStyle : rightBoxConveyorStyle, 
    boxName
  );

  try {
    console.log('📦 Fetching conveyor data for:', filename);
    const imageResponse = await getImageWithDetails(filename);
    if (imageResponse.conveyorData) {
      // Pass known filename to prevent duplicate fetch in batch updater
      addOrUpdateConveyorItem(imageResponse.conveyorData, boxName, portionIndex, isReplacement, filename);
    }
  } catch (error) {
    console.error('Error fetching conveyor data:', filename, error);
  }
};

// Helper function to generate image key
const getImageKey = useCallback((item, portionIndex, boxName, checkedItems) => {
  if (!item) return '';
  if (item.alt.startsWith('SP-')) {
    return `SPACER-${boxName}`;
  }

  // Include checkbox state for regular items to compute filename
  const selectedLabels = item.labels.filter(label => { 
    const key = `${portionIndex}-${label}`; 
    return checkedItems.get(key) === true;
  });

  const filename = generateConveyorFilename(
    selectedLabels,
    item.alt,
    boxName === 'left' ? leftBoxConveyorStyle : rightBoxConveyorStyle,
    boxName
  );

  const imageKey = `${boxName}-${filename}`;
  console.log(`🔑 Generated image key (box-aware): ${imageKey}`);
  return imageKey;
}, [generateConveyorFilename, leftBoxConveyorStyle, rightBoxConveyorStyle]);

console.log("set sample data",sampleData);
// New function to fetch conveyor details for multiple images
const fetchConveyorDetailsForImages = useCallback(async (imageNames, boxName, filenameGroups, knownDetails = {}) => {
  try {
    
    // Remove all existing entries for this box (but keep special label entries)
    setSampleData(prev => {
      console.log(`🗑️ Removing existing entries for ${boxName} box`);
      let updated = prev.filter(item => !(
        item.boxName === boxName && 
        !item.specialLabel // Keep special label entries (TA, STK, MT)
      ));
      
      // Create placeholder entries first - one per group. Spacers store a
      // synthetic groupKey (SPACER-NFT.jpg) but the real fetched filename
      // is on group.actualFilename — use it as the placeholder imageName so
      // detail lookup below resolves.
      Object.keys(filenameGroups).forEach(groupKey => {
        const group = filenameGroups[groupKey];
        const qty = group.portions.length;
        const isSpacerGroup = group.item?.alt?.startsWith('SP-');
        const placeholderImageName = isSpacerGroup ? (group.actualFilename || groupKey) : groupKey;

        const placeholderItem = {
          id: Date.now() + Math.random() + Math.random(),
          partName: `LOADING...`,
          partNumber: `LOADING...`,
          description: `LOADING....`,
          boxName,
          boxType: boxName === 'left' ? 'Infeed' : 'Outfeed',
          portionIndex: group.portions.join(','),
          qty: qty,
          listPrice: 0,
          discount: 0,
          actualPrice: 0,
          isNew: false,
          isEditing: false,
          imageName: placeholderImageName,
          spacerFt: isSpacerGroup ? (group.item.width || parseInt(group.item.alt.split('-')[1]) || 0) : 0
        };

        updated.push(placeholderItem);
      });

      console.log(`📊 Total entries`,updated);
      return updated;
    });

    // Fetch details for each unique image name
    const uniqueImageNames = [...new Set(imageNames)];
    const detailPromises = uniqueImageNames.map(async (imageName) => {
      // If we already have details for this imageName from the initiating action, reuse it
      if (knownDetails && knownDetails[imageName]) {
        return { imageName, conveyorData: knownDetails[imageName] };
      }
      try {
        const response = await getImageWithDetails(imageName);
        return {
          imageName,
          conveyorData: response.conveyorData
        };
      } catch (error) {
        console.error(`Error fetching details for ${imageName}:`, error);
        return {
          imageName,
          conveyorData: null
        };
      }
    });

    const details = await Promise.all(detailPromises);
    
    // Update quote data with fetched details
    setSampleData(prev => {
      const updated = prev.map(item => {
        if (item.boxName === boxName) {
          const detail = details.find(d => d.imageName === item.imageName);
          if (detail && detail.conveyorData) {
            const baseName = detail.conveyorData.conveyor_name || item.description;
            const description = item.spacerFt
              ? `${detail.conveyorData.conveyor_name || 'Spacer'} - ${item.spacerFt} FT`
              : baseName;
            return {
              ...item,
              partName: detail.conveyorData.part_number || item.partName,
              partNumber: detail.conveyorData.part_number || item.partNumber,
              description,
              listPrice: detail.conveyorData.list || 0,
              actualPrice: detail.conveyorData.list || 0
            };
          }
        }
        return item;
      });
      
      // STRICT VALIDATION: Ensure quote entries match image count after update
      const currentItems = boxName === 'left' ? leftBoxItems : rightBoxItems;
      const totalImageCount = Object.keys(currentItems).length;
      const boxQuoteEntries = updated.filter(item => item.boxName === boxName);
      const totalQuoteQuantity = boxQuoteEntries.reduce((sum, item) => sum + (item.qty || 0), 0);
      
      console.log(`🔍 POST-UPDATE VALIDATION: Images=${totalImageCount}, Quote Qty=${totalQuoteQuantity}`);
      
      if (totalImageCount !== totalQuoteQuantity) {
        console.error(`❌ POST-UPDATE VALIDATION FAILED: Image count (${totalImageCount}) does not match quote quantity (${totalQuoteQuantity})`);
        console.log(`📊 Box quote entries:`, boxQuoteEntries.map(item => `${item.partNumber} (qty: ${item.qty})`));
      } else {
        console.log(`✅ POST-UPDATE VALIDATION PASSED: Image count matches quote quantity`);
      }
      
      return updated;
    });

  } catch (error) {
    console.error('Error fetching conveyor details:', error);
  }
}, [getImageWithDetails,leftBoxItems, rightBoxItems, setSampleData]);

// Global validation function to ensure quote entries match image counts
const validateQuoteIntegrity = useCallback(() => {
  console.log(`🔍 GLOBAL VALIDATION: Checking quote integrity...`);
  
  const leftImageCount = Object.keys(leftBoxItems).length;
  const rightImageCount = Object.keys(rightBoxItems).length;
  
  const leftQuoteEntries = sampleData.filter(item => item.boxName === 'left' && !item.specialLabel);
  const rightQuoteEntries = sampleData.filter(item => item.boxName === 'right' && !item.specialLabel);
  
  const leftQuoteQuantity = leftQuoteEntries.reduce((sum, item) => sum + (item.qty || 0), 0);
  const rightQuoteQuantity = rightQuoteEntries.reduce((sum, item) => sum + (item.qty || 0), 0);
  
  console.log(`📊 Left Box: Images=${leftImageCount}, Quote Qty=${leftQuoteQuantity}`);
  console.log(`📊 Right Box: Images=${rightImageCount}, Quote Qty=${rightQuoteQuantity}`);
  
  const leftValid = leftImageCount === leftQuoteQuantity;
  const rightValid = rightImageCount === rightQuoteQuantity;
  
  if (!leftValid || !rightValid) {
    console.error(`❌ GLOBAL VALIDATION FAILED:`);
    if (!leftValid) console.error(`   Left Box: Image count (${leftImageCount}) ≠ Quote quantity (${leftQuoteQuantity})`);
    if (!rightValid) console.error(`   Right Box: Image count (${rightImageCount}) ≠ Quote quantity (${rightQuoteQuantity})`);
    return false;
  }
  
  console.log(`✅ GLOBAL VALIDATION PASSED: All boxes have correct quote quantities`);
  return true;
}, [leftBoxItems, rightBoxItems, sampleData]);

const forceCompleteRecalculation = useCallback((boxName, updatedCheckedItems) => {
  console.log(`🔄 FORCE COMPLETE RECALCULATION for ${boxName} box`);
  
  // Get the current items for this box
  const currentItems = boxName === 'left' ? leftBoxItems : rightBoxItems;
  
  if (!currentItems || Object.keys(currentItems).length === 0) return;

  // Generate image names for all items in the box using the updated state
  const imageNames = [];
  const filenameGroups = {};
  
  console.log(`🔄 Processing ${Object.keys(currentItems).length} items for ${boxName} box with updated state`);
  
  // Process each item in the box
  Object.keys(currentItems).forEach(portionIdx => {
    const item = currentItems[portionIdx];
    if (!item || item.type !== 'option') return;

    // Generate filename for this item based on the updated checkbox states
    const selectedLabels = item.labels.filter(l => {
      const key = `${portionIdx}-${l}`;
      const isLabelChecked = updatedCheckedItems[boxName].get(key) === true;

      // Skip special labels (TA, STK, MT) as they're handled separately
      if (['TA', 'STK', 'MT'].includes(l)) return false;

      console.log(`🔍 Portion ${portionIdx}, label ${l}: key=${key}, checked=${isLabelChecked}`);

      return isLabelChecked;
    });

    const filename = generateConveyorFilename(
      selectedLabels,
      item.alt,
      boxName === 'left' ? leftBoxConveyorStyle : rightBoxConveyorStyle,
      boxName
    );

    console.log(`📝 Portion ${portionIdx}: ${item.alt} with labels [${selectedLabels.join(',')}] → ${filename}`);

    // PW must flow into the primary filename so the backend resolves the
    // powered variant (e.g. BABS-10-P-24) instead of the non-powered variant
    // (BABS-10-NP-24). VR/CP are still excluded — they remain pure add-on
    // line items via upsertLabelOptionRow and must not change the primary row.
    const primaryLabels = selectedLabels.filter(l => l !== 'VR' && l !== 'CP');
    const primaryFilename = generateConveyorFilename(
      primaryLabels,
      item.alt,
      boxName === 'left' ? leftBoxConveyorStyle : rightBoxConveyorStyle,
      boxName,
      { swapFiveFt: false }
    );
    const groupKey = item.alt.startsWith('SP-')
      ? `SPACER-${item.width || item.alt.split('-')[1]}FT.jpg`
      : primaryFilename;
    if (!filenameGroups[groupKey]) {
      filenameGroups[groupKey] = {
        portions: [],
        item: item,
        selectedLabels: selectedLabels,
        actualFilename: filename
      };
    }
    filenameGroups[groupKey].portions.push(portionIdx);
    imageNames.push(item.alt.startsWith('SP-') ? filename : primaryFilename);
  });

  console.log(`📊 Filename groups:`, Object.keys(filenameGroups).map(f => `${f}: [${filenameGroups[f].portions.join(',')}]`));

  // STRICT VALIDATION: Ensure quote entries match image count
  const totalImageCount = Object.keys(currentItems).length;
  const totalQuoteQuantity = Object.values(filenameGroups).reduce((sum, group) => sum + group.portions.length, 0);
  
  console.log(`🔍 STRICT VALIDATION: Images=${totalImageCount}, Quote Qty=${totalQuoteQuantity}`);
  
  if (totalImageCount !== totalQuoteQuantity) {
    console.error(`❌ VALIDATION FAILED: Image count (${totalImageCount}) does not match quote quantity (${totalQuoteQuantity})`);
    console.log(`🔄 Forcing recalculation to fix discrepancy...`);
    
    // Force a complete recalculation to fix the discrepancy
    setTimeout(() => {
      forceCompleteRecalculation(boxName, updatedCheckedItems);
    }, 100);
    return;
  }
  
  console.log(`✅ VALIDATION PASSED: Image count matches quote quantity`);

  // Fetch conveyor details for all unique image names
  console.log(`🚀 Calling fetchConveyorDetailsForImages with ${imageNames.length} image names`);
  fetchConveyorDetailsForImages(imageNames, boxName, filenameGroups);
  
  // Run global validation after a short delay to ensure state is updated
  setTimeout(() => {
    validateQuoteIntegrity();
  }, 200);
}, [leftBoxItems, rightBoxItems, generateConveyorFilename, leftBoxConveyorStyle, rightBoxConveyorStyle, fetchConveyorDetailsForImages, validateQuoteIntegrity]);

const refreshQuoteData = useCallback(() => {

  // Create a deep copy of the current checked items state
  const currentCheckedItems = {
    left: new Map(checkedItems.left),
    right: new Map(checkedItems.right)
  };
  
  // Force complete recalculation for both boxes using current state
  forceCompleteRecalculation('left', currentCheckedItems);
  forceCompleteRecalculation('right', currentCheckedItems);
  
  // Validate integrity after refresh
  setTimeout(() => {
    validateQuoteIntegrity();
  }, 300);
}, [forceCompleteRecalculation, checkedItems, validateQuoteIntegrity]);


// here
const handleSpecialLabelChange = useCallback(async (boxName, portionIndex, label, isChecked) => {
  console.log(`🔧 Handling special label ${label} for ${boxName} box, portion ${portionIndex}, checked: ${isChecked}`);

  setCheckedItems(prev => {
    const newState = {
      left: new Map(prev.left),
      right: new Map(prev.right)
    };

    const key = `${portionIndex}-${label}`;
    newState[boxName].set(key, isChecked);

    const updatedLabelCount = Array.from(newState[boxName].entries()).filter(
      ([k, v]) => k.endsWith(`-${label}`) && v === true
    ).length;

    // For STK/TA labels, always add/remove per portion
    if (label === 'STK' || label === 'TA') {
      if (isChecked) {
        addSpecialLabelToQuote(boxName, label, null, portionIndex);
      } else {
        removeSpecialLabelFromQuote(boxName, label, portionIndex);
      }
    } else {
      // For other labels (MT), keep the old behavior
      if (isChecked && updatedLabelCount === 1) {
        addSpecialLabelToQuote(boxName, label, null, portionIndex);
      } else if (!isChecked && updatedLabelCount === 0) {
        removeSpecialLabelFromQuote(boxName, label);
      }
    }

    return newState;
  });
}, [addSpecialLabelToQuote, removeSpecialLabelFromQuote]);




const handleLabelChange = useCallback((boxName, portionIndex, label, isChecked) => {
  // Get the current items for this box
  const currentItems = boxName === 'left' ? leftBoxItems : rightBoxItems;
  
  if (!currentItems || Object.keys(currentItems).length === 0) return;

  console.log(`🔄 handleLabelChange called: ${boxName} box, portion ${portionIndex}, label ${label}, checked: ${isChecked}`);

  // Special handling for TA, STK, MT labels
  if (['TA', 'STK', 'MT'].includes(label)) {
    console.log(`🔧 Special handling for ${label} label`);
    handleSpecialLabelChange(boxName, portionIndex, label, isChecked);
    return;
  }

  // Normal handling for other labels
  const key = `${portionIndex}-${label}`;

  setCheckedItems(prev => {
    const newState = {
      left: new Map(prev.left),
      right: new Map(prev.right)
    };

    newState[boxName].set(key, isChecked);

    // Trigger recalculation with the updated state
    setTimeout(() => {
      console.log(`🔄 Forcing full recalculation for ${boxName} box after checkbox change`);
      forceCompleteRecalculation(boxName, newState);
    }, 0);

    return newState;
  });

  // PW/VR/CP are tracked as their own line items so they don't modify the
  // primary InFeed/OutFeed model row.
  if (LABEL_OPTION_LABELS.includes(label)) {
    setTimeout(() => { upsertLabelOptionRow(boxName, portionIndex, label, isChecked); }, 0);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [leftBoxItems, rightBoxItems, handleSpecialLabelChange, forceCompleteRecalculation, upsertLabelOptionRow]);

const useRefreshOnSampleDataChange = (sampleData, refreshQuoteData) => {
  const previousLengthRef = useRef(0);
  
  useEffect(() => {
    // Only refresh if sampleData length increased
    if (sampleData.length > 0 && sampleData.length !== previousLengthRef.current) {
      console.log("📊 Sample data updated - triggering automatic refresh", sampleData.length);
      
      const refreshTimer = setTimeout(() => {
        refreshQuoteData();
      }, 100);
      
      previousLengthRef.current = sampleData.length;
      
      return () => clearTimeout(refreshTimer);
    }
    
    previousLengthRef.current = sampleData.length;
  }, [sampleData.length, refreshQuoteData]);
};

// Then use it in your component:
useRefreshOnSampleDataChange(sampleData, refreshQuoteData);
  // ==============================================
  // UTILITY FUNCTIONS
  // ==============================================
  const getTodayDate = () => new Date().toISOString().split('T')[0];

  const calculateTotalLength = useCallback((boxItems) => {
    return boxItems.reduce((total, item) => {
      if (item.alt === '10FT' || item.alt === '10FTFORK') return total + 10;
      if (item.alt === '5FT' || item.alt === 'LFT') return total + 5;
      if (item.alt.startsWith('SP-')) {
        const spacerValue = parseInt(item.alt.split('-')[1]);
        return total + (isNaN(spacerValue) ? 0 : spacerValue);
      }
      return total;
    }, 0);
  }, []); 

  const validateLength = useCallback((length) => {
    return Math.min(Math.max(length, 0), LENGTH_LIMIT_MAX_FT);
  }, []);
  // ==============================================
  // DATA FETCHING & INITIALIZATION
  // ==============================================
useEffect(() => {
  const fetchQuoteData = async () => {
    if (!quoteId) return;
    
    try {
      const quoteRes = await getQuoteById(quoteId);
      if (quoteRes.success) {
        const quote = quoteRes.data;
        console.log("Quote DATS:",quote)
        
        // Set quote number
        setQuoteNumber(quote.quote_number || '');
        
        // Set form fields including date
        setFormFields({
          datumSide: quote.sawDetails?.datumSide || '',
          workBedHeight: quote.sawDetails?.workBedHeight?.toString() || '',
          sawType: quote.sawDetails?.sawType || '',
          quotePrice: quote.quote_price?.toString() || '',
          customerRFQ: quote.customer_rfq_number || '',
          standard_discount: quote.customer?.standard_discount || '',
          date: quote.date ? new Date(quote.date).toISOString().split('T')[0] : getTodayDate()
        });
        
        // Set customer
        if (quote.customer) {
          const customer = customers.find(c => 
            c.customer === quote.customer || 
            (c.customerData && c.customerData.customer === quote.customer)
          );
          if (customer) {
            setSelectedCustomer(customer);
            setSelectedCustomerName(customer.customer || customer.customerData?.customer);
            
            setFormFields(prev => ({
              ...prev,
              standard_discount: customer.standard_discount || ''
            }));
          }
        }
        
        // Set saw
        if (quote.saw_id_1039) {
          const saw = saws.find(s => s._id === quote.saw_id_1039);
          if (saw) {
            setSelectedSaw(saw);
            setFormFields(prev => ({
              ...prev,
              datumSide: saw.datum_side || '',
              workBedHeight: saw.work_bed_height?.toString() || '',
              sawType: saw.saw_type || ''
            }));
            
            if (saw.image_name) {
              const sawImageRes = await getSawImageData(saw.image_name);
              if (sawImageRes.success) {
                setSawImage(sawImageRes.url);
              }
            }
          }
        }
        
        // Set conveyor styles from modules
        const infeedStyle = quote.infeed_modules?.[0]?.style || '';
        const outfeedStyle = quote.outfeed_modules?.[0]?.style || '';
        
        setLeftBoxConveyorStyle(infeedStyle);
        setRightBoxConveyorStyle(outfeedStyle);
        
        // Set orientation
        setOrientation(quote.orientation || 'left-to-right');
        setIsRotatedArrow(quote.orientation === 'right-to-left');
        setItems(['Infeed', 'Material Flow', 'Outfeed']);
        
        // Reconstruct box items and checked states
        const leftItems = [];
        const leftChecked = new Map();
        quote.infeed_modules?.forEach((module, index) => {
          const isAngled = module.module_type === ATBL_ALT;
          leftItems.push({
            type: 'option',
            alt: module.module_type,
            labels: isAngled ? [] : ['PW', 'VR', 'MT', 'CP', 'STK', 'TA']
          });
          
          // Derive option toggle state from filename + *_yn first, then
          // module_options[0] (the latter was vestigial for VR/CP/MT/PW
          // prior to the 2026-05-13 backend fix).
          const derived = deriveModuleOptionStates(module);
          if (derived.pw) leftChecked.set(`${index}-PW`, true);
          if (derived.vr) leftChecked.set(`${index}-VR`, true);
          if (derived.cp) leftChecked.set(`${index}-CP`, true);
          if (derived.mt) leftChecked.set(`${index}-MT`, true);
          if (derived.stk) leftChecked.set(`${index}-STK`, true);
          if (derived.ta) leftChecked.set(`${index}-TA`, true);
          if (derived.stk) {
            setSTKSelections(prev => ({ ...prev, left: { ...(prev.left || {}), [index]: true } }));
          }
          if (derived.stkVariant) {
            setSTKVariantByPortion(prev => ({ ...prev, left: { ...(prev.left || {}), [index]: derived.stkVariant } }));
          }
        });
        // Set left flipped state if present on modules
        if (quote.infeed_modules && quote.infeed_modules.length > 0 && typeof quote.infeed_modules[0].flips === 'boolean') {
          setFlippedBoxes(prev => ({ ...prev, left: !!quote.infeed_modules[0].flips }));
          setFilenameFlipStates(prev => ({ ...prev, left: !!quote.infeed_modules[0].flips }));
        }
        setLeftBoxItems(leftItems);
        setCheckedItems(prev => ({ ...prev, left: leftChecked }));
        
        const rightItems = [];
        const rightChecked = new Map();
        quote.outfeed_modules?.forEach((module, index) => {
          const isAngled = module.module_type === ATBL_ALT;
          rightItems.push({
            type: 'option',
            alt: module.module_type,
            labels: isAngled ? [] : ['PW', 'VR', 'MT', 'CP', 'STK', 'TA']
          });
          
          const derived = deriveModuleOptionStates(module);
          if (derived.pw) rightChecked.set(`${index}-PW`, true);
          if (derived.vr) rightChecked.set(`${index}-VR`, true);
          if (derived.cp) rightChecked.set(`${index}-CP`, true);
          if (derived.mt) rightChecked.set(`${index}-MT`, true);
          if (derived.stk) rightChecked.set(`${index}-STK`, true);
          if (derived.ta) rightChecked.set(`${index}-TA`, true);
          if (derived.stk) {
            setSTKSelections(prev => ({ ...prev, right: { ...(prev.right || {}), [index]: true } }));
          }
          if (derived.stkVariant) {
            setSTKVariantByPortion(prev => ({ ...prev, right: { ...(prev.right || {}), [index]: derived.stkVariant } }));
          }
        });
        // Set right flipped state if present on modules
        if (quote.outfeed_modules && quote.outfeed_modules.length > 0 && typeof quote.outfeed_modules[0].flips === 'boolean') {
          setFlippedBoxes(prev => ({ ...prev, right: !!quote.outfeed_modules[0].flips }));
          setFilenameFlipStates(prev => ({ ...prev, right: !!quote.outfeed_modules[0].flips }));
        }
        setRightBoxItems(rightItems);
        setCheckedItems(prev => ({ ...prev, right: rightChecked }));
        
        // Calculate lengths
        const infeedLen = quote.infeed_modules?.reduce((sum, module) => sum + module.module_length, 0) || 0;
        const outfeedLen = quote.outfeed_modules?.reduce((sum, module) => sum + module.module_length, 0) || 0;
        setInfeedLength(infeedLen);
        setOutfeedLength(outfeedLen);
        
        // Set roller lengths
        if (quote.infeed_modules?.length > 0) {
          setLeftBoxRollerLength(quote.infeed_modules[0].module_roller_length || '');
        }
        if (quote.outfeed_modules?.length > 0) {
          setRightBoxRollerLength(quote.outfeed_modules[0].module_roller_length || '');
        }
        
        // Set motor variants (derive from module_options[0].mt, with
        // motor_hp_value as fallback when mt variant string was dropped).
        quote.infeed_modules?.forEach((module, index) => {
          const derived = deriveModuleOptionStates(module);
          if (derived.mt && derived.mtVariant) {
            setMotorVariantByBox(prev => ({ ...prev, left: derived.mtVariant }));
            setMotorSelections(prev => ({ ...prev, left: index.toString() }));
          }
        });

        quote.outfeed_modules?.forEach((module, index) => {
          const derived = deriveModuleOptionStates(module);
          if (derived.mt && derived.mtVariant) {
            setMotorVariantByBox(prev => ({ ...prev, right: derived.mtVariant }));
            setMotorSelections(prev => ({ ...prev, right: index.toString() }));
          }
        });
        
        // Set quote details
        if (quote.installation && quote.installation.length > 0) {
          const install = quote.installation[0];
          setQuoteDetails({
            color: quote.colors?.[0] || '',
            sawDelivery: quote.saw_delivery?.[0] || '',
            conveyorDelivery: quote.conveyor_delivery?.[0] || '',
            deliveryTerms: quote.babs_incoterms?.[0] || '',
            inspection: install.Inspection_and_Acceptance || '',
            warranty: install.Warranty || '',
            tax: install.Sales_Tax || '',
            payment: quote.payment_terms?.[0] || '',
            location: '',
            installation: {
              techs: install.Number_of_Service_Technicians || '1',
              days: install.Number_of_Days || '1',
              laborTotal: install.Hourly_Rate || '',
              installationTotal: install.Total_Price || '',
              showDetails: false,
              deliveryMethod: install.Delivery_Method || '',
              installationOption: install.Installation_Option || '',
              installQuoted: install.INSTALL_QUOTED || '',
              dayRate: install.Hourly_Rate || '',
              lodgingMeals: install.Lodging_Meals || '',
              carRental: install.Car_Rental || '',
              toolShipments: install.Tool_Shipments || '',
              airfare: install.Airfare || '',
              mileage: install.Mileage || '',
              travelTimeCost: install.Travel_Time_Cost || '',
              conveyorShippingPrice: install.Conveyor_Shipping_Price || ''
            }
          });
        }
        
        // Defer the label-replay (PW/VR/CP/MT/TA/STK → table rows) until
        // after leftBoxItems/rightBoxItems are committed; see the
        // pendingQuoteReplayRef useEffect below.
        pendingQuoteReplayRef.current = quote;

      } else {
        toast.error('Failed to fetch quote data');
        navigate('/quotes');
      }
    } catch (error) {
      console.error('Error fetching quote:', error);
      toast.error('An error occurred while fetching quote data');
    }
  };
  
  // Only fetch after dropdown data is loaded
  if (customers.length > 0 && saws.length > 0) {
    fetchQuoteData();
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [quoteId, customers, saws, getQuoteById, getSawImageData, navigate]);

// Replay label-option / special-label handlers AFTER leftBoxItems and
// rightBoxItems have been committed, so handleLabelChange and the
// label-option insert path read populated box arrays instead of bailing
// at the empty-items guard.
useEffect(() => {
  const quote = pendingQuoteReplayRef.current;
  if (!quote) return;
  const expectedLeft = quote.infeed_modules?.length || 0;
  const expectedRight = quote.outfeed_modules?.length || 0;
  if ((leftBoxItems?.length || 0) < expectedLeft) return;
  if ((rightBoxItems?.length || 0) < expectedRight) return;
  pendingQuoteReplayRef.current = null;

  quote.infeed_modules?.forEach((module, index) => {
    const derived = deriveModuleOptionStates(module);
    if (derived.mt) { try { handleLabelChange('left', index.toString(), 'MT', true); } catch (e) { /* noop */ } }
    if (derived.ta) { try { handleLabelChange('left', index, 'TA', true); } catch (e) { /* noop */ } }
    if (derived.stk) { try { handleLabelChange('left', index, 'STK', true); } catch (e) { /* noop */ } }
    if (derived.pw) { try { handleLabelChange('left', index, 'PW', true); } catch (e) { /* noop */ } }
    if (derived.vr) { try { handleLabelChange('left', index, 'VR', true); } catch (e) { /* noop */ } }
    if (derived.cp) { try { handleLabelChange('left', index, 'CP', true); } catch (e) { /* noop */ } }
  });
  quote.outfeed_modules?.forEach((module, index) => {
    const derived = deriveModuleOptionStates(module);
    if (derived.mt) { try { handleLabelChange('right', index.toString(), 'MT', true); } catch (e) { /* noop */ } }
    if (derived.ta) { try { handleLabelChange('right', index, 'TA', true); } catch (e) { /* noop */ } }
    if (derived.stk) { try { handleLabelChange('right', index, 'STK', true); } catch (e) { /* noop */ } }
    if (derived.pw) { try { handleLabelChange('right', index, 'PW', true); } catch (e) { /* noop */ } }
    if (derived.vr) { try { handleLabelChange('right', index, 'VR', true); } catch (e) { /* noop */ } }
    if (derived.cp) { try { handleLabelChange('right', index, 'CP', true); } catch (e) { /* noop */ } }
  });
}, [leftBoxItems, rightBoxItems, handleLabelChange]);


useEffect(() => {
  const fetchDropdownData = async () => {
    try {
      // Fetch conveyor styles from the specific API endpoint
      const conveyorRes = await getModularConveyors();
      
      if (conveyorRes.success && conveyorRes.conveyors) { // Changed from conveyorRes.data to conveyorRes.conveyors
        // Extract unique conveyor styles from the API response
        const uniqueConveyorStyles = [];
        const seenStyles = new Set();

        conveyorRes.conveyors.forEach(conveyor => { // Changed from conveyorRes.data to conveyorRes.conveyors
          const style = conveyor.conveyor_style || conveyor.style;
          if (style && !seenStyles.has(style)) {
            seenStyles.add(style);
            uniqueConveyorStyles.push({
              value: style,
              label: style
            });
          }
        });

        // Set the conveyor styles from API
        setDropdownOptions(prev => ({
          ...prev,
          conveyorStyles: uniqueConveyorStyles
        }));

        atblDocsRef.current = extractATBLDocs(conveyorRes.conveyors);
      }
      
      // Fetch other data if still needed
      const res = await getMultipleData(['customers', 'saws', 'products']);
      if (res.success) {
        setCustomers(res.data.customers || []);
        setSaws(res.data.saws || []);
        setConveyorStyles(res.data.products || []);
      }
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  };
  
  fetchDropdownData();
}, [getMultipleData, getModularConveyors]);

// EFFECT - CLEAR BOX ITEMS WHEN CONVEYOR STYLE CHANGES
// ==============================================
const handleConveyorStyleSelection = (style) => {
  setSelectedConveyorStyle(style);
  
  if (activeBox === 'left') {
    setLeftBoxConveyorStyle(style);
    // Trigger full clear for left (Infeed) - this will now clear quote details too
    handleClearBox('left');
    toast.success('Infeed cleared due to conveyor style change');
    // Reset roller length for left when user changes style
    setLeftBoxRollerLength('');
    setSelectedRollerLength('');
  } else {
    setRightBoxConveyorStyle(style);
    // Trigger full clear for right (Outfeed) - this will now clear quote details too
    handleClearBox('right');
    toast.success('Outfeed cleared due to conveyor style change');
    // Reset roller length for right when user changes style
    setRightBoxRollerLength('');
    setSelectedRollerLength('');
  }
};
  // ==============================================
  // EVENT HANDLERS - CUSTOMER RELATED
  // ==============================================
  const handleCustomerSelection = (customerName) => {
    const customer = customers.find(c => 
      c.customer === customerName || 
      (c.customerData && c.customerData.customer === customerName)
    );
    setSelectedCustomer(customer);
    setSelectedCustomerName(customer?.customer || customer?.customerData?.customer || customerName);

  if (customer) {
    setFormFields((prev) => ({
      ...prev,
      standard_discount: customer.standard_discount || ""   // fetch discount into form field
    }));
  }
  };
  // ==============================================
  // EVENT HANDLERS - SAW RELATED
  // ==============================================
const handleSawSelection = (selectedOption) => {
  const selected = saws.find(saw =>
    `${saw.brand || 'Unknown Brand'} - ${saw.model || 'Unknown Model'}` === selectedOption
  );
  setSelectedSaw(selected);
  
  // Set initial form fields from the basic saw data
  setFormFields(prev => ({
    ...prev,
    datumSide: selected?.datum_side || '',
    workBedHeight: selected?.work_bed_height?.toString() || '',
    sawType: selected?.saw_type || ''
  }));
};

// Clear the chosen saw. The quote can be saved with no saw selected — saw_id_1039
// serialises to '' and nothing requires a saw.
const handleRemoveSaw = () => {
  setSelectedSaw(null);
  setFormFields(prev => ({
    ...prev,
    datumSide: '',
    workBedHeight: '',
    sawType: ''
  }));
};

// Create a new saw from the "Add New Saw" dropdown option: persist it (POST /saws),
// refresh the list so it stays a permanent option, and auto-select it. Throws on failure
// so the CreateSaw modal stays open.
const handleAddNewSaw = async (formData) => {
  const { image, pdf, ...rest } = formData;
  const res = await createSaw(rest, image, pdf);
  if (!res?.success) {
    toast.error(res?.error || 'Failed to add saw');
    throw new Error(res?.error || 'Failed to add saw');
  }
  const listRes = await getMultipleData(['saws']);
  if (listRes?.success) setSaws(listRes.data || []);
  const created = res.saw;
  if (created) {
    setSelectedSaw(created);
    setFormFields(prev => ({
      ...prev,
      datumSide: created.datum_side || '',
      workBedHeight: created.work_bed_height?.toString() || '',
      sawType: created.saw_type || ''
    }));
  }
  toast.success('Saw added');
};

const sawOptions = [...saws].sort((a, b) => {
  const aBrand = (a.brand || 'Unknown Brand').toLowerCase();
  const bBrand = (b.brand || 'Unknown Brand').toLowerCase();
  const brandCompare = aBrand.localeCompare(bBrand);
  if (brandCompare !== 0) return brandCompare;
  const aModel = (a.model || 'Unknown Model').toLowerCase();
  const bModel = (b.model || 'Unknown Model').toLowerCase();
  return aModel.localeCompare(bModel);
}).map((saw) => `${saw.brand || 'Unknown Brand'} - ${saw.model || 'Unknown Model'}`);
  // ==============================================
  // EVENT HANDLERS - BOX RELATED
  // ==============================================
  const clearQuoteDetailsForBox = (boxName) => {
    setSampleData(prev => {
      // Filter out items that belong to the specified box
      return prev.filter(item => item.boxName !== boxName);
    });
  };

  const handleClearBox = (boxName) => {
    if (boxName === 'left') {
      setLeftBoxItems([]);
      setCheckedItems(prev => ({
        ...prev,
        left: new Map()  // Create a new empty Map
      }));
      setInfeedLength(0);
      
      // Clear motor selection for left box
      setMotorSelections(prev => ({
        ...prev,
        left: null
      }));
      
      // Clear TA selections for left box
      setTASelections(prev => ({
        ...prev,
        left: {}
      }));
      
      // Clear STK selections for left box
      setSTKSelections(prev => ({
        ...prev,
        left: {}
      }));
      setSTKVariantByPortion(prev => ({ ...prev, left: {} }));
      // Allow refreshQuoteData() to run once again for this box after clear
      setUsedRefreshOnce(prev => ({ ...prev, left: false }));
      
    } else {
      setRightBoxItems([]);
      setCheckedItems(prev => ({
        ...prev,
        right: new Map() // Create a new empty Map
      }));
      setOutfeedLength(0);
      
      // Clear motor selection for right box
      setMotorSelections(prev => ({
        ...prev,
        right: null
      }));
      
      // Clear TA selections for right box
      setTASelections(prev => ({
        ...prev,
        right: {}
      }));
      
      // Clear STK selections for right box
      setSTKSelections(prev => ({
        ...prev,
        right: {}
      }));
      setSTKVariantByPortion(prev => ({ ...prev, right: {} }));
      // Allow refreshQuoteData() to run once again for this box after clear
      setUsedRefreshOnce(prev => ({ ...prev, right: false }));
    }
    
    // Clear quote details for this box
    clearQuoteDetailsForBox(boxName);
    
    // Clear global image cache for items from this specific box only (keys prefixed with `${boxName}-`)
    setGlobalImageCache(prev => {
      const newCache = new Map(prev);
      for (const key of Array.from(newCache.keys())) {
        if (key.startsWith(`${boxName}-`)) newCache.delete(key);
      }
      return newCache;
    });
    
    // Trigger cache clear in BoxComponent
    if (boxName === 'left') {
      // Clear left box cache
      setLeftBoxCacheClear(prev => prev + 1);
    } else {
      // Clear right box cache
      setRightBoxCacheClear(prev => prev + 1);
    }
  };

  // OLD VERSION — preserved for reference. Replaced because it explicitly wiped
  // and rebuilt the box's quote-details rows on every flip, destroying user edits
  // (qty, discount, description, manualQty, custom prices). The new version is
  // visual-only: it toggles flip state, clears the URL cache so the diagram
  // refetches the flipped images, and uses flipSuppressRef to swallow the
  // sampleData-mutation cascade triggered by that refetch.
  // const handleVerticalFlip = async (boxName) => {
  //   console.log(`🔄 Vertical flip for ${boxName} box`);
  //
  //   // First, clear the existing quote details for this box
  //   clearQuoteDetailsForBox(boxName);
  //
  //   // Update the flip states
  //   setFlippedBoxes(prev => ({
  //     ...prev,
  //     [boxName]: !prev[boxName]
  //   }));
  //
  //   setFilenameFlipStates(prev => ({
  //     ...prev,
  //     [boxName]: !prev[boxName]
  //   }));
  //
  //   // Get current checked items for this box
  //   const currentCheckedItems = {
  //     left: new Map(checkedItems.left),
  //     right: new Map(checkedItems.right)
  //   };
  //
  //   // Use a small delay to ensure state updates before regenerating
  //   setTimeout(() => {
  //     // Force complete recalculation to regenerate quote details for regular items
  //     forceCompleteRecalculation(boxName, currentCheckedItems);
  //
  //     // Also regenerate special label items (TA, STK, MT)
  //     regenerateSpecialLabelItems(boxName, currentCheckedItems[boxName]);
  //   }, 100);
  // };

  const handleVerticalFlip = async (boxName) => {
    console.log(`🔄 Vertical flip for ${boxName} box (visual-only)`);

    // Count option items in this box so we can suppress that exact number of
    // sampleData rebuild calls triggered by the cache-invalidation refetch.
    const items = boxName === 'left' ? leftBoxItems : rightBoxItems;
    const optionCount = Array.isArray(items)
      ? items.filter(it => it && it.type === 'option').length
      : Object.keys(items || {}).filter(k => items[k] && items[k].type === 'option').length;
    flipSuppressRef.current[boxName] = optionCount;

    // Clear only this box's URL cache so the diagram refetches the flipped images.
    setGlobalImageCache(prev => {
      const newCache = new Map(prev);
      for (const key of Array.from(newCache.keys())) {
        if (key.startsWith(`${boxName}-`)) newCache.delete(key);
      }
      return newCache;
    });

    // Toggle flip states.
    setFlippedBoxes(prev => ({ ...prev, [boxName]: !prev[boxName] }));
    setFilenameFlipStates(prev => ({ ...prev, [boxName]: !prev[boxName] }));

    // Safety: clear stale suppression after 5s if some fetches never resolve.
    setTimeout(() => { flipSuppressRef.current[boxName] = 0; }, 5000);
  };

// Improved regenerateSpecialLabelItems function
const regenerateSpecialLabelItems = async (boxName, checkedItemsMap) => {
  console.log(`🔄 Regenerating special labels for ${boxName} box`);

  // Find all checked special labels
  const checkedSpecialLabels = Array.from(checkedItemsMap.entries())
    .filter(([key, value]) => value === true && 
          (key.endsWith('-TA') || key.endsWith('-STK') || key.endsWith('-MT')))
    .map(([key]) => {
      const [portionIndex, label] = key.split('-');
      return { portionIndex, label };
    });

  // Clear existing special label entries for this box
  setSampleData(prev => prev.filter(item => !(
    item.boxName === boxName && item.specialLabel
  )));

  // If nothing selected → nothing to add
  if (checkedSpecialLabels.length === 0) return;

  for (const { portionIndex, label } of checkedSpecialLabels) {
    let details = null;
    const isFlipped = filenameFlipStates[boxName];

    switch(label) {
      case 'MT':
        // Use the motor variant details for this box
        details = motorDetailsByBox[boxName];
        break;
      case 'TA':
        // Use per-box TA details (flipped → down, not flipped → up)
        details = isFlipped ? taDetails[boxName]?.down : taDetails[boxName]?.up;
        break;
      case 'STK': {
        // Use per-box STK details with variant support (flipped → low, not flipped → high)
        const stkVariant = stkVariantByPortion?.[boxName]?.[portionIndex] || '5FT';
        const stkSuffix = stkVariant === '5FT' ? '' : stkVariant;
        const highKey = stkSuffix ? `high${stkSuffix}` : 'high';
        const lowKey = stkSuffix ? `low${stkSuffix}` : 'low';
        details = isFlipped ? stkDetails[boxName]?.[lowKey] : stkDetails[boxName]?.[highKey];
        break;
      }
      default:
        details = null;
    }

    if (details) {
      const isPortionScoped = label === 'STK' || label === 'TA';
      setSampleData(prev => [
        ...prev,
        {
          id: Date.now() + Math.random(),
          partName: details.part_number || `${label} Component`,
          partNumber: details.part_number || label,
          description: details.conveyor_name || `${label} Component`,
          boxName,
          boxType: boxName === 'left' ? 'Infeed' : 'Outfeed',
          portionIndex: isPortionScoped ? portionIndex : 'special',
          qty: 1,
          listPrice: details.list || 0,
          discount: 0,
          actualPrice: details.list || 0,
          isNew: false,
          isEditing: false,
          imageName: getSpecialLabelFilename(label, boxName, portionIndex),
          specialLabel: label,
          motorIndex: portionIndex || 'special'
        }
      ]);
    }
  }
};
//=============== CHECK BOXES CHANGE + ARROW + OPTIONS WITH IMAGES =====================
  const handleMTCheckboxChange = (boxName, portionIndex, isChecked) => {
    // Determine conveyor style to check if Heavy Duty (auto 5hp) vs Extreme Duty (dropdown)
    const styleValue = boxName === 'left' ? leftBoxConveyorStyle : rightBoxConveyorStyle;
    const styleStr = (typeof styleValue === 'string' ? styleValue : styleValue?.value || '').toUpperCase();
    const isExtremeDuty = styleStr.includes('EX') || styleStr.includes('EXTREME');

    setMotorSelections(prev => {
      const newSelections = {...prev};

      if (isChecked) {
        newSelections[boxName] = portionIndex;

        setCheckedItems(prevChecked => {
          const newChecked = {
            left: new Map(prevChecked.left),
            right: new Map(prevChecked.right)
          };

          newChecked[boxName].set(`${portionIndex}-MT`, true);

          for (const [key] of newChecked[boxName]) {
            if (key.endsWith('-MT') && key !== `${portionIndex}-MT`) {
              newChecked[boxName].set(key, false);
            }
          }

          return newChecked;
        });
        // For Heavy Duty (non-Extreme), auto-select 5hp motor
        if (!isExtremeDuty) {
          setMotorVariantByBox(prev => ({ ...prev, [boxName]: 'motor' }));
        }
      } else {
        if (newSelections[boxName] === portionIndex) {
          newSelections[boxName] = null;

          setCheckedItems(prevChecked => {
            const newChecked = {
              left: new Map(prevChecked.left),
              right: new Map(prevChecked.right)
            };

            newChecked[boxName].set(`${portionIndex}-MT`, false);
            return newChecked;
          });
          // Clear motor variant on uncheck
          setMotorVariantByBox(prev => ({ ...prev, [boxName]: '' }));
        }
      }

      return newSelections;
    });

    // Handle quote generation with updated checkbox state
    setTimeout(() => {
      handleLabelChange(boxName, portionIndex, 'MT', isChecked);
    }, 0);
  };
  //========TA=======
  const handleTACheckboxChange = (boxName, portionIndex, isChecked, imageUrl) => {
    setTASelections(prev => {
      const newSelections = {...prev};
      
      if (isChecked) {
        // Add the TA selection with its image URL
        newSelections[boxName] = {
          ...newSelections[boxName],
          [portionIndex]: imageUrl
        };
      } else {
        // Remove the TA selection
        const updatedSelections = {...newSelections[boxName]};
        delete updatedSelections[portionIndex];
        newSelections[boxName] = updatedSelections;
      }
      
      return newSelections;
    });

    // Update checkedItems separately
    setCheckedItems(prevChecked => {
      const newChecked = {
        left: new Map(prevChecked.left),
        right: new Map(prevChecked.right)
      };
      
      const key = `${portionIndex}-TA`;
      newChecked[boxName].set(key, isChecked);
      
      return newChecked;
    });

    // Handle quote generation with updated checkbox state
    setTimeout(() => {
      handleLabelChange(boxName, portionIndex, 'TA', isChecked);
    }, 0);
  };
  //===========STK
  const handleSTKCheckboxChange = (boxName, portionIndex, isChecked, imageUrl) => {
    setSTKSelections(prev => {
      const newSelections = {...prev};
      
      if (isChecked) {
        // Add the STK selection with its image URL
        newSelections[boxName] = {
          ...newSelections[boxName],
          [portionIndex]: imageUrl
        };
      } else {
        // Remove the STK selection
        const updatedSelections = {...newSelections[boxName]};
        delete updatedSelections[portionIndex];
        newSelections[boxName] = updatedSelections;
      }
      
      return newSelections;
    });

    // Update checkedItems separately
    setCheckedItems(prevChecked => {
      const newChecked = {
        left: new Map(prevChecked.left),
        right: new Map(prevChecked.right)
      };
      
      const key = `${portionIndex}-STK`;
      newChecked[boxName].set(key, isChecked);
      
      return newChecked;
    });

    // Handle quote generation with updated checkbox state
    setTimeout(() => {
      handleLabelChange(boxName, portionIndex, 'STK', isChecked);
    }, 0);
  };
  //=============
  const handleSTKChange = async (boxName, portionIndex, value) => {
    const variant = value?.target?.value || value;

    setSTKVariantByPortion(prev => ({
      ...prev,
      [boxName]: {
        ...(prev[boxName] || {}),
        [portionIndex]: variant
      }
    }));

    const key = `${portionIndex}-STK`;
    const isStkSelected = checkedItems[boxName]?.get(key) === true;

    if (isStkSelected) {
      removeSpecialLabelFromQuote(boxName, 'STK', portionIndex);

      const isFlipped = filenameFlipStates[boxName];

      // Try preloaded stkDetails first
      let detailsKey;
      if (variant === '5FT') detailsKey = isFlipped ? 'low' : 'high';
      else if (variant === '10FT') detailsKey = isFlipped ? 'low10FT' : 'high10FT';
      else if (variant === '15FT') detailsKey = isFlipped ? 'low15FT' : 'high15FT';
      else if (variant === '20FT') detailsKey = isFlipped ? 'low20FT' : 'high20FT';

      let conveyorData = stkDetails[boxName]?.[detailsKey] || null;

      if (!conveyorData) {
        // Fallback to API fetch — STK filenames are universal
        const stkSize = variant.replace('FT', '');
        const stkHeight = isFlipped ? 'LOW' : 'HIGH';
        const filename = `BABS-${stkSize}-STKA-BO-${stkHeight}.jpg`;

        try {
          const response = await getImageWithDetails(filename);
          conveyorData = response?.conveyorData || null;
        } catch (error) {
          console.error('Error updating STK details:', error);
        }
      }

      if (conveyorData) {
        addSpecialLabelToQuote(boxName, 'STK', conveyorData, portionIndex);
      }
    }
  };

  const handleCheckboxChange = (boxName, portionIndex, label) => {
    // Special handling for MT label
    if (label === 'MT') {
      const key = `${portionIndex}-${label}`;
      const currentValue = checkedItems[boxName].get(key) || false;
      handleMTCheckboxChange(boxName, portionIndex, !currentValue);
      return;
    }

    // Special handling for TA label
    if (label === 'TA') {
      const key = `${portionIndex}-${label}`;
      const currentValue = checkedItems[boxName].get(key) || false;
      handleTACheckboxChange(boxName, portionIndex, !currentValue);
      return;
    }

    // Special handling for STK label
    if (label === 'STK') {
      const key = `${portionIndex}-${label}`;
      const currentValue = checkedItems[boxName].get(key) || false;
      handleSTKCheckboxChange(boxName, portionIndex, !currentValue);
      return;
    }

    // Normal handling for other labels
    const key = `${portionIndex}-${label}`;
    const currentValue = checkedItems[boxName].get(key) || false;
    const newValue = !currentValue;

    console.log(
      `🔄 Checkbox change: ${boxName} box, portion ${portionIndex}, label ${label}, current: ${currentValue} → new: ${newValue}`
    );

    // Update checkbox state and immediately recalculate
    setCheckedItems(prev => {
      const newState = {
        left: new Map(prev.left),
        right: new Map(prev.right)
      };

      newState[boxName].set(key, newValue);

      // Trigger recalculation with the updated state
      setTimeout(() => {
        console.log(`🔄 Recalculating for ${boxName} box after checkbox change`);

        // Use refreshQuoteData() only the first time per box, then always force
        if (!usedRefreshOnce[boxName]) {
          refreshQuoteData();
          setUsedRefreshOnce(prev => ({ ...prev, [boxName]: true }));
        } else {
          forceCompleteRecalculation(boxName, newState);
        }
      }, 0);

      return newState;
    });
  };

    const handleBoxItemsChange = (boxName, newItems) => {
      if (boxName === 'left') {
        setLeftBoxItems(newItems);
        const totalLength = calculateTotalLength(newItems);
        setInfeedLength(validateLength(totalLength));
      } else {
        setRightBoxItems(newItems);
        const totalLength = calculateTotalLength(newItems);
        setOutfeedLength(validateLength(totalLength));
      }
    };

  const handleCheckedItemsChange = (boxName, newCheckedItems) => {
    setCheckedItems(prev => ({
      ...prev,
      [boxName]: newCheckedItems
    }));
  };

const handleDeletePortion = useCallback((boxName, portionIndex) => {
  const indexNum = parseInt(portionIndex, 10);
  const isLeft = boxName === 'left';
  const currentItems = isLeft ? leftBoxItems : rightBoxItems;
  if (!currentItems || indexNum < 0 || indexNum >= currentItems.length) return;

  // Remove the module at index
  const newItems = currentItems.filter((_, i) => i !== indexNum);
  if (isLeft) { 
    setLeftBoxItems(newItems); 
  } else { 
    setRightBoxItems(newItems); 
  }

  // Create a new checked items map with updated indices
  const newCheckedItemsMap = new Map();
  const currentCheckedItems = checkedItems[boxName];
  
  // Process all existing checked items
  for (const [key, value] of currentCheckedItems) {
    const [keyIndex, label] = key.split('-');
    const keyIndexNum = parseInt(keyIndex, 10);
    
    // Skip items from the deleted portion
    if (keyIndexNum === indexNum) continue;
    
    // Update indices for portions after the deleted one
    if (keyIndexNum > indexNum) {
      const newKey = `${keyIndexNum - 1}-${label}`;
      newCheckedItemsMap.set(newKey, value);
    } else {
      // Keep items from portions before the deleted one
      newCheckedItemsMap.set(key, value);
    }
  }

  // Count remaining special labels
  const mtCount = Array.from(newCheckedItemsMap.entries())
    .filter(([k, v]) => /-MT$/.test(k) && v === true).length;
  const taCount = Array.from(newCheckedItemsMap.entries())
    .filter(([k, v]) => /-TA$/.test(k) && v === true).length;
  const stkCount = Array.from(newCheckedItemsMap.entries())
    .filter(([k, v]) => /-STK$/.test(k) && v === true).length;
  
  const noMT = mtCount === 0;
  const noTA = taCount === 0;
  const noSTK = stkCount === 0;

  // Update checked items state
  setCheckedItems(prev => ({
    ...prev,
    [boxName]: newCheckedItemsMap
  }));

  // Update motor selections with new indices
  setMotorSelections(prev => {
    const newSelections = { ...prev };
    const currentSelection = newSelections[boxName];
    
    if (currentSelection !== null) {
      const selectionIndex = parseInt(currentSelection, 10);
      if (selectionIndex === indexNum) {
        // Remove selection if it was the deleted portion
        newSelections[boxName] = null;
      } else if (selectionIndex > indexNum) {
        // Update index if it was after the deleted portion
        newSelections[boxName] = (selectionIndex - 1).toString();
      }
    }
    
    return newSelections;
  });

  // Update TA selections with new indices
  setTASelections(prev => {
    const newSelections = { ...prev };
    const boxSelections = { ...(newSelections[boxName] || {}) };
    const updatedBoxSelections = {};
    
    Object.keys(boxSelections).forEach(key => {
      const keyIndex = parseInt(key, 10);
      if (keyIndex === indexNum) {
        // Skip the deleted portion
        return;
      }
      
      if (keyIndex > indexNum) {
        // Update index for portions after the deleted one
        updatedBoxSelections[keyIndex - 1] = boxSelections[key];
      } else {
        // Keep portions before the deleted one
        updatedBoxSelections[keyIndex] = boxSelections[key];
      }
    });
    
    newSelections[boxName] = updatedBoxSelections;
    return newSelections;
  });

  // Update STK selections with new indices
  setSTKSelections(prev => {
    const newSelections = { ...prev };
    const boxSelections = { ...(newSelections[boxName] || {}) };
    const updatedBoxSelections = {};
    
    Object.keys(boxSelections).forEach(key => {
      const keyIndex = parseInt(key, 10);
      if (keyIndex === indexNum) {
        // Skip the deleted portion
        return;
      }
      
      if (keyIndex > indexNum) {
        // Update index for portions after the deleted one
        updatedBoxSelections[keyIndex - 1] = boxSelections[key];
      } else {
        // Keep portions before the deleted one
        updatedBoxSelections[keyIndex] = boxSelections[key];
      }
    });
    
    newSelections[boxName] = updatedBoxSelections;
    return newSelections;
  });

  // Update STK variant selections with new indices
  setSTKVariantByPortion(prev => {
    const newSelections = { ...prev };
    const boxSelections = { ...(newSelections[boxName] || {}) };
    const updatedBoxSelections = {};

    Object.keys(boxSelections).forEach(key => {
      const keyIndex = parseInt(key, 10);
      if (keyIndex === indexNum) return;
      if (keyIndex > indexNum) {
        updatedBoxSelections[keyIndex - 1] = boxSelections[key];
      } else {
        updatedBoxSelections[keyIndex] = boxSelections[key];
      }
    });

    newSelections[boxName] = updatedBoxSelections;
    return newSelections;
  });

  // Update sampleData
  setSampleData(prev => {
    return prev.filter(item => {
      // Remove non-special items that are entirely for this portion
      if (item.boxName === boxName && !item.specialLabel) {
        if (!item.portionIndex) return true;
        const parts = String(item.portionIndex).split(',');
        const remaining = parts.filter(p => p !== String(portionIndex));
        
        // Remove if no portions remain
        if (remaining.length === 0) return false;
        
        // Adjust quantity and portionIndex if needed
        if (remaining.length !== parts.length) {
          item.qty = remaining.length;
          item.portionIndex = remaining.join(',');
        }
        return true;
      }
      
      // Remove special items if no more of that type exist
      if (item.boxName === boxName && item.specialLabel) {
        if (item.specialLabel === 'MT' && noMT) return false;
        if (item.specialLabel === 'TA' && noTA) return false;
        if (item.specialLabel === 'STK' && noSTK) return false;
        return true;
      }
      
      // Keep all other items
      return true;
    });
  });

  // Clear cached images for this box
  setGlobalImageCache(prev => {
    const copy = new Map(prev);
    for (const key of Array.from(copy.keys())) {
      if (key.startsWith(`${boxName}-`)) copy.delete(key);
    }
    return copy;
  });

  // Recompute lengths
  const totalLength = calculateTotalLength(newItems);
  if (isLeft) { 
    setInfeedLength(validateLength(totalLength)); 
  } else { 
    setOutfeedLength(validateLength(totalLength)); 
  }
}, [leftBoxItems, rightBoxItems, setLeftBoxItems, setRightBoxItems, checkedItems, setCheckedItems, setMotorSelections, setTASelections, setSTKSelections, setSampleData, setGlobalImageCache, calculateTotalLength, setInfeedLength, setOutfeedLength, validateLength]);
 
const handleArrowClick = () => {
    setIsRotatedArrow(!isRotatedArrow);
    setOrientation((prev) =>
      prev === "left-to-right" ? "right-to-left" : "left-to-right"
    );

    // First, update the quote entries to reflect the box swap
    setSampleData(prev => {
      return prev.map(item => {
        if (item.boxName === 'left') {
          return {...item, boxName: 'right', boxType: 'Outfeed'};
        } else if (item.boxName === 'right') {
          return {...item, boxName: 'left', boxType: 'Infeed'};
        }
        return item;
      });
    });

    // Swap box items
    const tempItems = [...leftBoxItems];
    setLeftBoxItems([...rightBoxItems]);
    setRightBoxItems(tempItems);

    // Swap checked items
    setCheckedItems((prev) => ({
      left: new Map(prev.right),
      right: new Map(prev.left),
    }));

    // Swap flipped states
    setFlippedBoxes({
      left: flippedBoxes.right,
      right: flippedBoxes.left,
    });

    // Swap filename flip states
    setFilenameFlipStates({
      left: filenameFlipStates.right,
      right: filenameFlipStates.left,
    });

    // Swap conveyor styles
    const tempStyle = leftBoxConveyorStyle;
    setLeftBoxConveyorStyle(rightBoxConveyorStyle);
    setRightBoxConveyorStyle(tempStyle);

    // Swap roller lengths per box, and sync the active selectedRollerLength accordingly
    const tempRL = leftBoxRollerLength;
    setLeftBoxRollerLength(rightBoxRollerLength);
    setRightBoxRollerLength(tempRL);
    setSelectedRollerLength(prev => (activeBox === 'left' ? rightBoxRollerLength : leftBoxRollerLength));

    // Swap motor selections
    setMotorSelections((prev) => ({
      left: prev.right,
      right: prev.left,
    }));

    // Swap motor variants and details so dropdown choice and details follow the box
    setMotorVariantByBox((prev) => ({
      left: prev.right,
      right: prev.left,
    }));
    setMotorDetailsByBox((prev) => ({
      left: prev.right,
      right: prev.left,
    }));

    // Swap TA selections
    setTASelections((prev) => ({
      left: prev.right,
      right: prev.left,
    }));
    
    // Swap STK selections
    setSTKSelections((prev) => ({
      left: prev.right,
      right: prev.left,
    }));
    setSTKVariantByPortion((prev) => ({
      left: prev.right,
      right: prev.left,
    }));

    // Swap infeed and outfeed lengths
    const tempLength = infeedLength;
    setInfeedLength(outfeedLength);
    setOutfeedLength(tempLength);

    // Clear the global image cache to prevent stale images
    setGlobalImageCache(new Map());

    // After swapping via arrow, ensure future recalculations use force (not refresh)
    setUsedRefreshOnce({ left: true, right: true });
  };

  // ok motor

  const addOptionWithImage = useCallback((imgSrc, imgAlt) => {
    const boxSetter = isRotatedBox ? setRightBoxItems : setLeftBoxItems;
    const lengthSetter = isRotatedBox ? setOutfeedLength : setInfeedLength;
    
    const currentItems = isRotatedBox ? rightBoxItems : leftBoxItems;
    const currentLength = calculateTotalLength(currentItems);
    
    let itemLength = 0;
    if (imgAlt === '10FT' || imgAlt === '10FTFORK') itemLength = 10;
    else if (imgAlt === '5FT' || imgAlt === 'LFT') itemLength = 5;
    else if (imgAlt.startsWith('SP-')) itemLength = parseInt(imgAlt.split('-')[1]) || 0;

    if (currentLength + itemLength > LENGTH_LIMIT_MAX_FT) {
      const remaining = LENGTH_LIMIT_MAX_FT - currentLength;
      setLengthLimitMessage(
        <>
          Cannot add {itemLength}ft item. Maximum length is {LENGTH_LIMIT_MAX_FT}ft.
          <br />
          Only <span className="text-red-600 font-bold">{remaining}</span>ft remaining.
        </>
      );
      setShowLengthLimitModal(true);
      return;
    }

    // Angled tables expose no PW/VR/CP/MT/STK/TA toggles — give them an empty labels array
    // so the picker doesn't render the sub-option checkboxes.
    const labelArray = imgAlt === ATBL_ALT ? [] : ['PW', 'VR', 'MT', 'CP', 'STK', 'TA'];
    const newItem = {
      type: 'option',
      src: imgSrc,
      alt: imgAlt,
      labels: labelArray
    };

    boxSetter((prev) => {
      const newItems = [...prev, newItem];
      const totalLength = calculateTotalLength(newItems);
      lengthSetter(validateLength(totalLength));
      return newItems;
    });
  }, [isRotatedBox, rightBoxItems, leftBoxItems, calculateTotalLength, validateLength]);

  const handleLiftTable = useCallback(() => addOptionWithImage(liftTable, 'LFT'), [addOptionWithImage]);
  const handle5FtModel = useCallback(() => addOptionWithImage(fiveFtModel, '5FT'), [addOptionWithImage]);
  const handle10FtModel = useCallback(() => addOptionWithImage(tenFtModel, '10FT'), [addOptionWithImage]);
  const handle10FtForkModel = useCallback(() => addOptionWithImage(tenFtForkModel, '10FTFORK'), [addOptionWithImage]);
  const handleAngledTable = useCallback(() => {
    const targetBox = isRotatedBox ? 'right' : 'left';
    const isFlipped = !!filenameFlipStates[targetBox];
    const doc = pickATBLDoc(atblDocsRef.current, targetBox, isFlipped);
    if (!doc) {
      toast.error('Angled Table assets are not available — try again in a moment.');
      return;
    }
    addOptionWithImage(null, ATBL_ALT);
  }, [addOptionWithImage, isRotatedBox, filenameFlipStates]);

  // ==============================================
  // EVENT HANDLERS - CREATE / UPDATE QUOTE + TABLE
  // ==============================================
  const topRef = useRef(null);

  useEffect(() => {
    if (isQuoteCreated) {
      console.log('Scrolling to top, current scrollY:', window.scrollY);
      
      // Force immediate scroll first
      window.scrollTo(0, 0);
      
      // Then smooth scroll after a brief delay to ensure DOM is stable
      setTimeout(() => {
        // Scroll to the top of the page
        window.scrollTo({ top: 0, behavior: 'smooth' });
        
        // Also try scrolling to the ref element
        if (topRef.current) {
          topRef.current.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start',
            inline: 'nearest'
          });
        }
        
        console.log('After scroll attempt, scrollY:', window.scrollY);
        
        // Reset the flag after scrolling is complete
        setTimeout(() => {
          setIsQuoteCreated(false);
        }, 500);
      }, 100);
    }
  }, [isQuoteCreated]);

const handleUpdateQuoteButton = async () => {
  if (!selectedCustomer) {
    toast.error('Please select a customer');
    return;
  }

  if (!quoteNumber) {
    toast.error('Quote number is missing');
    return;
  }

  try {
    const customerName = selectedCustomer.customer || 
                       selectedCustomer.customerData?.customer || 
                       'Unknown Customer';

    // Convert Map to regular objects for JSON serialization
    // const leftCheckedItems = Object.fromEntries(checkedItems.left);
    // const rightCheckedItems = Object.fromEntries(checkedItems.right);

    // Helper function to generate module data with proper motor variant handling
    const generateModuleData = (items, checkedItemsMap, conveyorStyle, rollerLength, boxName) => {
      return items.map((item, index) => {
        // Get selected labels for this module
        const selectedLabels = item.labels.filter(label => {
          const key = `${index}-${label}`;
          return checkedItemsMap.get(key) === true;
        });
        
        // Generate filename using the existing function
        const filename = generateConveyorFilename(
          selectedLabels,
          item.alt,
          conveyorStyle,
          boxName
        );

        // Determine motor variant for this module
        let motorVariant = '';
        // Fix: Convert index to string for comparison
        if (motorSelections[boxName] === index.toString()) {
          motorVariant = motorVariantByBox[boxName] || '';
        }

        // Check for special selections
        const hasMotor = checkedItemsMap.get(`${index}-MT`) || false;
        const hasVerticalRoller = checkedItemsMap.get(`${index}-VR`) || false;
        const hasCoolantPan = checkedItemsMap.get(`${index}-CP`) || false;
        
        // Get motor HP value if motor is selected
        let motorHpValue = '';
        if (hasMotor && motorSelections[boxName] === index.toString()) {
          const motorVariantType = motorVariantByBox[boxName];
          if (motorVariantType === 'motor') motorHpValue = '5HP';
          else if (motorVariantType === 'motor1') motorHpValue = '3HP';
          else if (motorVariantType === 'motor2') motorHpValue = '7.5HP';
        }

        return {
          module_type: item.alt,
          module_length: calculateModuleLength(item.alt),
          style: conveyorStyle,
          module_roller_length: rollerLength,
          filename: filename,
          flips: !!flippedBoxes[boxName],
          motor_yn: hasMotor ? 'YES' : 'NO',
          motor_hp_value: motorHpValue,
          vertical_roller_yn: hasVerticalRoller ? 'YES' : 'NO',
          coolant_pan_yn: hasCoolantPan ? 'YES' : 'NO',
          // Fix: Format module_options as an array of objects
          module_options: [{
            pw: checkedItemsMap.get(`${index}-PW`) || false,
            vr: checkedItemsMap.get(`${index}-VR`) || false,
            mt: motorVariant, // Now using the correctly determined motor variant
            cp: checkedItemsMap.get(`${index}-CP`) || false,
            stk: checkedItemsMap.get(`${index}-STK`) || false,
            ta: checkedItemsMap.get(`${index}-TA`) || false,
            stkVariant: checkedItemsMap.get(`${index}-STK`) ? (stkVariantByPortion?.[boxName]?.[index] || '') : ''
          }]
        };
      });
    };

    // Transform the data to match your schema
    const quoteData = {
      _id: quoteId, // Include quote ID for update
      quote_number: quoteNumber,
      customer: customerName,
      date: new Date(getTodayDate()),
      orientation: orientation,
      quote_price: formFields.quotePrice || 0,
      standard_discount: parseFloat(formFields.standard_discount) || 0,
      grand_total: computeGrandTotal({
        parts: sampleData,
        installationTotal: quoteDetails.installation?.installationTotal,
        taxStr: quoteDetails.tax,
        defaultDiscount: formFields.standard_discount,
      }),
      customerRFQ: formFields.customerRFQ,
      customer_rfq_number: formFields.customerRFQ || '',
      infeed_conveyor_style: leftBoxConveyorStyle,
      outfeed_conveyor_style: rightBoxConveyorStyle,
      saw_id_1039: selectedSaw?._id || '',
      
      // Generate infeed modules with additional data
      infeed_modules: generateModuleData(
        leftBoxItems, 
        checkedItems.left, 
        leftBoxConveyorStyle, 
        leftBoxRollerLength, 
        'left'
      ),
      
      // Generate outfeed modules with additional data
      outfeed_modules: generateModuleData(
        rightBoxItems, 
        checkedItems.right, 
        rightBoxConveyorStyle, 
        rightBoxRollerLength, 
        'right'
      ),
      
      // Map installation details
      installation: [{
        Delivery_Method: quoteDetails.installation?.deliveryMethod,
        Installation_Option: quoteDetails.installation?.installationOption,
        Number_of_Service_Technicians: quoteDetails.installation?.techs || '1',
        Number_of_Days: quoteDetails.installation?.days || '1',
        Hourly_Rate: quoteDetails.installation?.dayRate || '',
        Lodging_Meals: quoteDetails.installation?.lodgingMeals || '',
        Car_Rental: quoteDetails.installation?.carRental || '',
        Tool_Shipments: quoteDetails.installation?.toolShipments || '',
        Airfare: quoteDetails.installation?.airfare || '',
        Mileage: quoteDetails.installation?.mileage || '',
        Travel_Time_Cost: quoteDetails.installation?.travelTimeCost || '',
        Conveyor_Shipping_Price: quoteDetails.installation?.conveyorShippingPrice || '',
        Total_Price: quoteDetails.installation?.installationTotal || '',
        Warranty: quoteDetails.warranty || '',
        Sales_Tax: quoteDetails.tax || '',
        Payment_Terms: quoteDetails.payment || '',
        Saw_Delivery_Schedule: quoteDetails.sawDelivery || '',
        Conveyor_Delivery_Schedule: quoteDetails.conveyorDelivery || '',
        Conveyor_Color: quoteDetails.color || '',
        Inspection_and_Acceptance: quoteDetails.inspection || '',
        INSTALL_QUOTED: quoteDetails.installation?.installQuoted || ''  
      }],
      
      // Map other arrays
      colors: quoteDetails.color ? [quoteDetails.color] : [],
      payment_terms: quoteDetails.payment ? [quoteDetails.payment] : [],
      babs_incoterms: quoteDetails.deliveryTerms ? [quoteDetails.deliveryTerms] : [],
      saw_delivery: quoteDetails.sawDelivery ? [quoteDetails.sawDelivery] : [],
      conveyor_delivery: quoteDetails.conveyorDelivery ? [quoteDetails.conveyorDelivery] : [],
      
      parts: sampleData,
      
      updatedBy: user?.name || 'Unknown',
      updatedAt: new Date().toISOString()
    };

    console.log('Updating quote with data:', JSON.stringify(quoteData, null, 2));

    const result = await updateQuoteVersion(quoteNumber, quoteData);
    
    if (result.success) {
      toast.success('Quote updated successfully!');
      navigate('/quotes'); // Navigate to quotes page after success
    } else {
      const errorMessage = result.error?.message || 
                          result.message || 
                          'Failed to update quote';
      toast.error(errorMessage);
    }
  } catch (error) {
    console.error('Error updating quote:', error);
    const errorMessage = error.response?.data?.message || 
                        error.message || 
                        'An unexpected error occurred. Please try again.';
    toast.error(errorMessage);
  }
};
//============================================================================
// Helper function to calculate module length
const calculateModuleLength = (alt) => {
  if (alt.startsWith('SP-')) return parseInt(alt.split('-')[1]) || 0;
  if (alt === '10FT' || alt === '10FTFORK') return 10;
  if (alt === '5FT' || alt === 'LFT') return 5;
  return 0;
};

  const handleCreateQuote = async (quoteDetails) => {
    if (!selectedCustomer) {
      toast.error('Please select a customer');
      return { success: false, error: 'Customer not selected' };
    }

    if (!quoteNumber) {
      toast.error('Quote number is missing');
      return { success: false, error: 'Missing quote number' };
    }

    try {
      const customerData = {
        _id: selectedCustomer._id,
        customer: selectedCustomer.customer || selectedCustomer.customerData?.customer,
        title: selectedCustomer.title || selectedCustomer.customerData?.title,
        phone: selectedCustomer.phone || selectedCustomer.customerData?.phone,
        email: selectedCustomer.email || selectedCustomer.customerData?.email
      };

      const quoteData = {
        quote_number: quoteNumber,
        customer: customerData,
        date: new Date(formFields.date || getTodayDate()),
        orientation,
        customerRFQ: formFields.customerRFQ,
        saw_id_1039: selectedSaw?._id || '',
        sawDetails: {
          type: formFields.sawType,
          workBedHeight: formFields.workBedHeight,
          datumSide: formFields.datumSide,
          model: selectedSaw ? `${selectedSaw.brand} - ${selectedSaw.model}` : ''
        },
      };

      const result = await createQuote(quoteData);
      
      if (result.success) {
        toast.success('Quote created successfully!');
        return result;
      } else {
        toast.error(result.error || 'Failed to create quote');
        return { success: false, error: result.error };
      }
    } catch (error) {
      console.error('Error creating quote:', error);
      toast.error('An unexpected error occurred. Please try again.');
      return { success: false, error: error.message };
    }
  };

  const handleSubmitData = async (tableData) => {
    const quoteDetails = {
      quoteNumber,
      customer: selectedCustomer,
      customerRFQ: formFields.customerRFQ,
      quotePrice: formFields.quotePrice,
      date: getTodayDate(),
      selectedSaw,
      sawType: formFields.sawType,
      workBedHeight: formFields.workBedHeight,
      datumSide: formFields.datumSide,
      rollerLength: selectedRollerLength,
      conveyorStyle: selectedConveyorStyle,
      orientation,
      infeedLength,
      outfeedLength,
      leftBoxItems,
      rightBoxItems,
      checkedItems,
      // isReversed,
      parts: tableData,
      createdBy: user?.name || 'Unknown',
      createdAt: new Date().toISOString(),
    };

    handleCreateQuote(quoteDetails);
  };

  // ==============================================
  // EVENT HANDLERS - FORM RELATED
  // ==============================================
const handleInputChange = (field, value) => {
  setFormFields(prev => ({
    ...prev,
    [field]: value
  }));
};

  // const handleDropdownChange = (value, setStateFn) => {
  //   if (value.startsWith('Enter Custom')) {
  //     const type = value.replace('Enter Custom ', '');
  //     handleCustomOptionSelect(type, setStateFn);
  //   } else {
  //     setStateFn(value);
  //   }
  // };

  // Dedicated handler to keep per-box roller length in sync
  const handleRollerLengthSelect = (value) => {
    setSelectedRollerLength(value);
    if (activeBox === 'left') {
      setLeftBoxRollerLength(value);
    } else {
      setRightBoxRollerLength(value);
    }
  };

//   const handleCustomOptionSelect = (type, setStateFn) => {
//     setCustomType(type);
//     setCustomCallback((value) => {
//       const formattedValue = `${value}"`;
//       setStateFn(formattedValue);
      
//       const styleKey = typeof selectedConveyorStyle === 'string' 
//         ? selectedConveyorStyle 
//         : selectedConveyorStyle.value;
      
// setDropdownOptions(prev => ({
//   ...prev,
//   rollerLengths: {
//     ...prev.rollerLengths,
//     [styleKey]: [
//       ...(prev.rollerLengths[styleKey] || []).filter(item => item !== 'Enter Custom Length'),
//       formattedValue
//       // Removed 'Enter Custom Length' - don't add it back
//     ]
//   }
// }));
//     });
//     setCustomModalOpen(true);
//   };

  const handleAddNew = () => {
    const newItem = {
      id: Date.now(),
      partName: '',
      description: '',
      qty: '',
      listPrice: '',
      discount: '',
      actualPrice: '',
      isNew: true,
      isEditing: true
    };
    
    setSampleData(prev => [...prev, newItem]);
    setIsAddingNew(true);
  };

// ==============================================
// UTILITY FUNCTIONS - CONVEYOR RELATED (generateConveyorFilename)
// ==============================================
const getCurrentRollerLengths = useCallback(() => {
  if (!selectedConveyorStyle) return [];
  
  const styleValue = typeof selectedConveyorStyle === 'string' 
    ? selectedConveyorStyle 
    : selectedConveyorStyle.value;

  const styleMap = {
    'HEAVY DUTY': 'HD',
    'EXTREME DUTY': 'EX',
    'SIGMA STYLE': 'SG',
    'HD': 'HD',
    'EX': 'EX',
    'SG': 'SG'
  };

  const styleKey = styleMap[styleValue.toUpperCase()] || 'DEFAULT';
  const lengths = dropdownOptions.rollerLengths[styleKey] || dropdownOptions.rollerLengths.DEFAULT;
  
  return lengths;
}, [selectedConveyorStyle, dropdownOptions.rollerLengths]);

//============================================================================================


// ==============================================
// EFFECTS
// ==============================================
// Keep selectedRollerLength in sync with the active box's per-box length
useEffect(() => {
  if (activeBox === 'left') {
    setSelectedRollerLength(leftBoxRollerLength || '');
  } else {
    setSelectedRollerLength(rightBoxRollerLength || '');
  }
}, [activeBox, leftBoxRollerLength, rightBoxRollerLength]);

// Keep global selectedConveyorStyle in sync with the active box's style
useEffect(() => {
  if (activeBox === 'left') {
    setSelectedConveyorStyle(leftBoxConveyorStyle);
  } else {
    setSelectedConveyorStyle(rightBoxConveyorStyle);
  }
}, [activeBox, leftBoxConveyorStyle, rightBoxConveyorStyle]);

// // Clear image display when switching boxes
// useEffect(() => {
//   clearImageDisplay();
// }, [activeBox]);

useEffect(() => {
  const normalizedStyle = typeof selectedConveyorStyle === 'string' 
    ? selectedConveyorStyle.toUpperCase().replace(/\s+/g, '')
    : selectedConveyorStyle?.value?.toUpperCase().replace(/\s+/g, '') || '';

  const hasRequiredSelections = normalizedStyle && selectedRollerLength;

  if (normalizedStyle.includes('HD') || normalizedStyle.includes('HEAVYDUTY')) {
    // Heavy Duty: Show all buttons
    setButtonsEnabled({
      tenFt: hasRequiredSelections,
      tenFtFork: hasRequiredSelections,
      fiveFt: hasRequiredSelections,
      liftTable: hasRequiredSelections,
      spacer: hasRequiredSelections
    });
  } else if (normalizedStyle.includes('SG') || normalizedStyle.includes('SIGMA')) {
    // Sigma Style: Hide liftTable and tenFtFork
    setButtonsEnabled({
      tenFt: hasRequiredSelections,
      tenFtFork: false, // Hidden
      fiveFt: hasRequiredSelections,
      liftTable: false, // Hidden
      spacer: hasRequiredSelections
    });
  } else if (normalizedStyle.includes('EX') || normalizedStyle.includes('EXTREME')) {
    // Extreme Duty: Hide liftTable and tenFtFork
    setButtonsEnabled({
      tenFt: hasRequiredSelections,
      tenFtFork: false, // Hidden
      fiveFt: hasRequiredSelections,
      liftTable: false, // Hidden
      spacer: hasRequiredSelections
    });
  } else if (normalizedStyle) {
    // Other styles: Show all buttons
    setButtonsEnabled({
      tenFt: hasRequiredSelections,
      tenFtFork: hasRequiredSelections,
      fiveFt: hasRequiredSelections,
      liftTable: hasRequiredSelections,
      spacer: hasRequiredSelections
    });
  } else {
    // No style selected: Disable all buttons
    setButtonsEnabled({
      tenFt: false,
      tenFtFork: false,
      fiveFt: false,
      liftTable: false,
      spacer: false
    });
  }
}, [selectedConveyorStyle, selectedRollerLength]);
//========================================
  // Exit handler for the "Exit" button (onExit on TableComponent). It previously only
  // closed the unrelated custom-value modal, so confirming Exit never left the page.
  // Navigate to /quotes to match every other "leave the quote" path.
  const handleCloseModal = () => {
  setCustomModalOpen(false);
  navigate('/quotes');
};

// ++++++++++++++++++++++++++++++++++++++++ooooooooooooooooookkkkkkkkkkk+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// Add this function to your NewQuote component

  return (
    <div className="p-2  space-y-2 relative -mt-4">
      <div ref={topRef} className="absolute top-0"></div>

{/* Quote Info + Customer + Buttons in One Row */}
<div className="grid grid-cols-10 gap-2 items-stretch">
  <div className="col-span-10 md:col-span-4 flex flex-col">
    <h2 className="text-xs font-medium text-gray-600 mb-1">Quote Info & Date</h2>
    <div className="bg-white p-2 rounded shadow grid grid-cols-1 md:grid-cols-3 gap-2 h-full">
      <SmallInputField label="Quote Number" value={quoteNumber} readOnly width="w-full"/>
      <SmallInputField label="Quote Price ($)" type="number" value={formFields.quotePrice} onChange={(e) => handleInputChange("quotePrice", e.target.value)} placeholder="0.00" step="0.01" width="w-full"/>
      <SmallInputField label="Date" type="date" value={formFields.date} readOnly width="w-full"/>
    </div>
  </div>
  <div className="col-span-10 md:col-span-6 flex flex-col">
    <h2 className="text-xs font-medium text-gray-600 mb-1">Customer & RFQ</h2>
    <div className="bg-white p-1.5 rounded shadow flex flex-wrap items-start gap-2 h-full mt-0.5">
      <SmallDropdown label="Customer" items={customers.map((c) => c.customer || c.customerData?.customer || "Unnamed Customer")} selected={selectedCustomerName} onSelect={(value) => handleCustomerSelection(value)} width="w-72"/>
      <SmallInputField label="Customer RFQ" value={formFields.customerRFQ} onChange={(e) => handleInputChange("customerRFQ", e.target.value)} placeholder="Enter RFQ" width="w-36"/>
      <SmallInputField label="Standard Discount %" value={formFields.standard_discount || ""} onChange={(e) => handleInputChange("standard_discount", e.target.value)} placeholder="Discount %" width="w-36" readOnly/>
    </div>
  </div>
</div>


{/* Saw Section */}
<div>
  <h2 className="text-xs font-medium text-gray-600 mb-1">Saw & Conveyor Details</h2>
  <div className="bg-white p-3 rounded shadow">
    {/* First row with all controls except Brochure */}
    <div className="flex flex-wrap gap-3 overflow-x-auto pb-2">
      <SmallDropdown label="Conveyor Style" items={dropdownOptions?.conveyorStyles?.map((s) => s.label)} selected={dropdownOptions.conveyorStyles?.find((s) => s.value === selectedConveyorStyle)?.label || ""} onSelect={(v) => handleConveyorStyleSelection(dropdownOptions.conveyorStyles?.find((s) => s.label === v)?.value || "")} className="text-sm w-full sm:w-40 flex-shrink-0" />
      <SmallDropdown label="Roller Length" items={getCurrentRollerLengths()} selected={selectedRollerLength} onSelect={(v) => handleRollerLengthSelect(v)} disabled={!selectedConveyorStyle} className="text-sm w-full sm:w-28 flex-shrink-0" />
      <div className="flex items-end gap-1 w-full sm:w-auto flex-shrink-0">
        <SmallDropdown label="Saw Brand & Model" items={[ADD_NEW_SAW_OPTION, ...sawOptions]} selected={selectedSaw ? `${selectedSaw.brand || 'Unknown Brand'} - ${selectedSaw.model || 'Unknown Model'}` : ''} onSelect={(v) => v === ADD_NEW_SAW_OPTION ? setShowAddSaw(true) : handleSawSelection(v)} className="text-sm w-full sm:w-52" />
        {selectedSaw && (
          <button
            type="button"
            onClick={handleRemoveSaw}
            title="Remove saw"
            className="mb-[1px] inline-flex items-center justify-center h-[26px] px-2 text-[11px] font-medium rounded text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-1 focus:ring-red-400 flex-shrink-0"
          >
            Remove
          </button>
        )}
      </div>
      <div className="flex gap-2 flex-shrink-0 w-full sm:w-auto">
        <SmallInputField label="Datum Side" value={formFields.datumSide} readOnly className="text-sm w-full sm:w-28" />
        <SmallInputField label="Work Bed Height" value={formFields.workBedHeight} readOnly className="text-sm w-full sm:w-28" />
      </div>
      <SmallInputField label="Saw Type" value={formFields.sawType} readOnly className="text-sm w-full sm:w-52 flex-shrink-0" />
    </div>

    {/* Second row with 10-column grid */}
    <div className="grid grid-cols-10 gap-3 -mt-3">
      {/* Brochure column (2/10) */}
      <div className="col-span-2 mt-1.5">
        <div className='-mb-1'><label className="mb-2.5 text-xs font-semibold text-gray-700 block">Brochure</label></div>
        <div className="h-6 flex items-center justify-center mt-2">
          {selectedSaw ? (
            selectedSaw.brochure && selectedSaw.brochure !== 'No Brochure' ? (
              <a href={selectedSaw.brochure} target="_blank" rel="noopener noreferrer" download className="inline-flex items-center px-2 py-1 text-xs border border-transparent font-medium rounded text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-red-500 w-full text-center justify-center">
                <svg className="mr-1 h-5 w-3" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z" clipRule="evenodd" /></svg> Download
              </a>
            ) : <span className="text-gray-500 text-xs block">No brochure</span>
          ) : <span className="text-gray-500 text-xs block">Select Saw First</span>}
        </div>
      </div>

      {/* Description column (8/10) */}
      <div className="col-span-8">
        <label className="mb-1 text-xs font-semibold text-gray-700">Description</label>
        <textarea className="w-full px-2 py-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-red-500 bg-gray-50" value={selectedSaw?.description || ''} readOnly rows={1} />
      </div>
    </div>
  </div>
</div>
{/* Buttons - 5 columns in a row */}
<div className="col-span-10 md:col-span-5 flex flex-col">
  {/* Status message block */}
  <div className="mb-1">
    {!selectedConveyorStyle && (
      <p className="text-yellow-600 text-xs">
        Please select a conveyor style to continue
      </p>
    )}
    {selectedConveyorStyle && !selectedRollerLength && (
      <p className="text-yellow-600 text-xs">
        Please select a roller length to enable configuration options
      </p>
    )}
    {selectedConveyorStyle && selectedRollerLength && (
      <p className="text-green-600 text-xs">
        You can now add configuration options
      </p>
    )}
  </div>

  {/* Button Grid */}
  <div className="grid grid-cols-6 gap-1 w-full bg-white p-1.5 rounded shadow">
    <button
      onClick={handle10FtModel}
      disabled={!buttonsEnabled.tenFt}
      className={`bg-gradient-to-r from-red-600 to-red-800 text-white text-[10px] font-medium px-1 py-0.5 rounded shadow ${
        !buttonsEnabled.tenFt ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      Add 10FT Model
    </button>

    <button
      onClick={() => setShowSpacerModal(true)}
      disabled={!buttonsEnabled.spacer}
      className={`bg-gradient-to-r from-red-600 to-red-800 text-white text-[10px] font-medium px-1 py-0.5 rounded shadow ${
        !buttonsEnabled.spacer ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      Add Space
    </button>

    <button
      onClick={handle5FtModel}
      disabled={!buttonsEnabled.fiveFt}
      className={`bg-gradient-to-r from-red-600 to-red-800 text-white text-[10px] font-medium px-1 py-0.5 rounded shadow ${
        !buttonsEnabled.fiveFt ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      Add 5FT Model
    </button>

    <button
      onClick={handleLiftTable}
      disabled={!buttonsEnabled.liftTable}
      className={`bg-gradient-to-r from-red-600 to-red-800 text-white text-[10px] font-medium px-1 py-0.5 rounded shadow ${
        !buttonsEnabled.liftTable ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      Add Lift Table
    </button>

    <button
      onClick={handleAngledTable}
      disabled={!buttonsEnabled.liftTable}
      className={`bg-gradient-to-r from-red-600 to-red-800 text-white text-[10px] font-medium px-1 py-0.5 rounded shadow ${
        !buttonsEnabled.liftTable ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      Add Angled Table
    </button>

    <button
      onClick={handle10FtForkModel}
      disabled={!buttonsEnabled.tenFtFork}
      className={`bg-gradient-to-r from-red-600 to-red-800 text-white text-[10px] font-medium px-1 py-0.5 rounded shadow ${
        !buttonsEnabled.tenFtFork ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      Add 10FT Model with Forklift
    </button>
  </div>
</div>
      {/* Infeed/Outfeed Controls & Arrow & Boxes */}
      <div className="w-full bg-white py-1 px-4 rounded-xl shadow-md">

        {/* Controls Row */}
        <div className="flex items-center justify-between mb-6">
          {/* Infeed Controls - Left Side */}
          <div className="flex items-center gap-2 -mb-4">
            <button
              onClick={() => handleClearBox("left")}
              className="px-2 py-1 text-xs font-medium text-white bg-red-600 rounded hover:bg-red-700 transition whitespace-nowrap"
            >
              Clear Infeed
            </button>
            <div className="relative">
              <label className="absolute -top-4 left-0 text-xs font-sm text-gray-700">
                Infeed Length (FT)
              </label>
              <input
                type="number"
                className="w-24 px-1.5 py-0.5 text-xs border border-gray-300 rounded focus:ring-blue-500 focus:border-blue-500 bg-gray-100 cursor-default"
                value={infeedLength}
                onChange={(e) => {
                  const value = parseInt(e.target.value) || 0;
                  if (value > LENGTH_LIMIT_MAX_FT) {
                    setLengthLimitMessage(`Maximum length is ${LENGTH_LIMIT_MAX_FT}ft`);
                    setShowLengthLimitModal(true);
                    setInfeedLength(LENGTH_LIMIT_MAX_FT);
                  } else {
                    setInfeedLength(value);
                  }
                }}
                min="0"
                max={LENGTH_LIMIT_MAX_FT}
                step="0.1"
                readOnly
              />
            </div>
          </div>

          {/* Arrow - Centered */}
          <div
            onClick={handleArrowClick}
            className="cursor-pointer hover:scale-105 -mb-4"
            title="Toggle options"
          >
            <ArrowBox
              items={items}
              isRotated={isRotatedArrow}
              orientation={orientation}
            />
          </div>

{/* Outfeed Controls - Right Side */}
<div className="flex items-center gap-2 -mb-4">
  <div className="relative">
    <label className="absolute -top-4 left-0 text-xs font-sm text-gray-700">
      Out-f Length (FT)
    </label>
    <input
      type="number"
      className="w-24 px-1.5 py-0.5 text-xs border border-gray-300 rounded focus:ring-blue-500 focus:border-blue-500 bg-gray-100 cursor-default"
      value={outfeedLength}
      onChange={(e) => {
        const value = parseFloat(e.target.value) || 0;
        if (value > LENGTH_LIMIT_MAX_FT) {
          setLengthLimitMessage(`Maximum length is ${LENGTH_LIMIT_MAX_FT}ft`);
          setShowLengthLimitModal(true);
          setOutfeedLength(LENGTH_LIMIT_MAX_FT);
        } else {
          setOutfeedLength(value);
        }
      }}
      min="0"
      max={LENGTH_LIMIT_MAX_FT}
      step="0.1"
      readOnly
    />
  </div>
  <button
    onClick={() => handleClearBox("right")}
    className="px-2 py-1 text-xs font-medium text-white bg-red-600 rounded hover:bg-red-700 transition whitespace-nowrap"
  >
    Clear Outfeed
  </button>
</div>
        </div>

        {/* Boxes and Saw Image */}
<div className="flex justify-center items-center gap-2 relative quote-boxes-exclude">
  {/* Left Flip Button */}
  <FlipButton
    position="left"
    onClick={() => handleVerticalFlip("left")}
    isFlipped={isFlipped}
    setIsFlipped={setIsFlipped}
  />

  <BoxComponent
    boxItems={leftBoxItems}
    boxName="left"
    isRotatedBox={isRotatedBox}
    setIsRotatedBox={setIsRotatedBox}
    checkedItems={checkedItems.left}
    handleCheckboxChange={handleCheckboxChange}
    conveyorStyle={leftBoxConveyorStyle}
    generateConveyorFilename={generateConveyorFilename}
    // isReversed={isReversed}
    isFlippedVertically={flippedBoxes.left}
    onBoxItemsChange={handleBoxItemsChange}
    onCheckedItemsChange={handleCheckedItemsChange}
    setActiveBox={setActiveBox}
    motorSelections={motorSelections}
    taSelections={taSelections}
    filenameFlipStates={filenameFlipStates}
    stkSelections={stkSelections}
    globalImageCache={globalImageCache}
    setGlobalImageCache={setGlobalImageCache}
    cacheClearTrigger={leftBoxCacheClear}
    getImageForSelection={getImageForSelection}
    getImageKey={getImageKey}
    leftBoxConveyorStyle={leftBoxConveyorStyle}
    rightBoxConveyorStyle={rightBoxConveyorStyle}
  motorImageUrls={{
    left: motorVariantImageUrls.left,
    right: motorVariantImageUrls.right
  }}
  taImageUrls={{
    left: taImageUrls.left,
    right: taImageUrls.right
  }}
  stkImageUrls={{
    left: stkImageUrls.left,
    right: stkImageUrls.right
  }}
    onMotorSelect={handleMotorSelect}
    motorVariantByBox={motorVariantByBox}
    onDeletePortion={handleDeletePortion}
    stkVariantByPortion={stkVariantByPortion}
    handleSTKChange={handleSTKChange}
  />

  {/* Saw Image Container - Added negative margin top */}
  <div className="w-20 h-[500px] flex items-center justify-center -mt-6">
    {selectedSaw ? (
      sawImage ? (
        // Image exists
        <img
          src={sawImage}
          alt="Saw"
          className="max-w-full max-h-full"
          // className={`max-w-full max-h-full ${
          //   isRotatedArrow ? "rotate-[90deg]" : "rotate-[-90deg]"
          // }`}
        />
      ) : (
        // No image found
        <div className="text-gray-500 text-sm">
          No saw image available
        </div>
      )
    ) : (
      // No saw selected
      <div className="text-gray-500 text-sm">Select a saw</div>
    )}
  </div>

  <BoxComponent
    boxItems={rightBoxItems}
    boxName="right"
    isRotatedBox={isRotatedBox}
    setIsRotatedBox={setIsRotatedBox}
    checkedItems={checkedItems.right}
    generateConveyorFilename={generateConveyorFilename}
    conveyorStyle={rightBoxConveyorStyle}
    handleCheckboxChange={handleCheckboxChange}
    // isReversed={isReversed}
    isFlippedVertically={flippedBoxes.right}
    onBoxItemsChange={handleBoxItemsChange}
    onCheckedItemsChange={handleCheckedItemsChange}
    setActiveBox={setActiveBox}
    motorSelections={motorSelections}
    taSelections={taSelections}
    filenameFlipStates={filenameFlipStates}
    stkSelections={stkSelections}
    globalImageCache={globalImageCache}
    setGlobalImageCache={setGlobalImageCache}
    cacheClearTrigger={rightBoxCacheClear}
    getImageForSelection={getImageForSelection}
    getImageKey={getImageKey}
    leftBoxConveyorStyle={leftBoxConveyorStyle}
    rightBoxConveyorStyle={rightBoxConveyorStyle}
   motorImageUrls={{
    left: motorVariantImageUrls.left,
    right: motorVariantImageUrls.right
  }}
  taImageUrls={{
    left: taImageUrls.left,
    right: taImageUrls.right
  }}
  stkImageUrls={{
    left: stkImageUrls.left,
    right: stkImageUrls.right
  }}
    onMotorSelect={handleMotorSelect}
    motorVariantByBox={motorVariantByBox}
    onDeletePortion={handleDeletePortion}
    stkVariantByPortion={stkVariantByPortion}
    handleSTKChange={handleSTKChange}
  />

  {/* Right Flip Button */}
  <FlipButton
    position="right"
    onClick={() => handleVerticalFlip("right")}
    isFlipped={isFlipped}
    setIsFlipped={setIsFlipped}
  />
</div>
      </div>

      {/* Quote Details And Table */}
      <div className="w-full max-w-7xl mx-auto px-4 py-8 bg-white shadow-lg rounded-xl">
        <div className="flex justify-between items-center mb-6 border-b pb-2 -mt-2">
          <h1 className="text-xl font-extrabold text-red-600">
            Quotes Details
          </h1>
          <div className="flex gap-3">
            <button
              onClick={handleAddNew}
              disabled={isAddingNew}
              className={`px-4 py-2.5 text-sm font-medium rounded-lg shadow-sm transition-all duration-200 flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-opacity-50 active:scale-[0.98] border ${
                isAddingNew
                  ? "bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed"
                  : "bg-slate-200 text-gray-800 hover:bg-slate-300 hover:shadow-md focus:ring-gray-300 border-gray-300"
              }`}
            >
              <Plus className="h-4 w-4" strokeWidth={2.5} />
              <span>New Item</span>
            </button>
            <button
              onClick={() => setShowQuoteDetailsModal(true)}
              className="bg-gradient-to-r from-red-600 to-red-800 text-white font-medium px-4 py-2 rounded-lg shadow hover:scale-105 transition"
            >
              Additional Quote Details
            </button>
          </div>
        </div>

        <div className="overflow-x-auto mb-8">
          {/* asa hai */}
          <TableComponent
            data={sampleData}
            quoteNumber={quoteNumber}
            quoteDetails={quoteDetails}
            setQuoteDetails={setQuoteDetails}
            discount={formFields.standard_discount}
            customerData={selectedCustomer}
            onSave={(updatedItem) => {
              if (updatedItem._delete) {
                setSampleData((prev) =>
                  prev.filter((item) => item.id !== updatedItem.id)
                );
              } else {
                setSampleData((prev) =>
                  prev.map((item) =>
                    item.id === updatedItem.id ? updatedItem : item
                  )
                );
              }
              setIsAddingNew(false); // Reset when saved
            }}
            onClear={() => {
              setSampleData([]);
            }}
            onExit={handleCloseModal}
            onPublish={handleSubmitData}
            isAddingNew={isAddingNew} // Pass the state
            onCancelAddNew={(id) => {
              // Add this handler
              setSampleData((prev) => prev.filter((item) => item.id !== id));
              setIsAddingNew(false);
            }}
          />
        </div>

        <CustomModal
          isOpen={customModalOpen}
          onCancel={() => setCustomModalOpen(false)}
          onConfirm={(value) => {
            // customCallback(value);
            setCustomModalOpen(false);
          }}
          // customType={customType}
        />

        {/* Create Quote Button */}
        <div className="flex justify-center -mt-2">
          <button
            onClick={handleUpdateQuoteButton}
            disabled={isQuoteCreated || isAddingNew}
            className={`px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors duration-200 ${
              isQuoteCreated || isAddingNew
                ? "opacity-50 cursor-not-allowed bg-slate-400 hover:bg-slate-500"
                : ""
            }`}
          >
            {isQuoteCreated ? "Quote Updated" : "Update Quote"}
          </button>
        </div>
      </div>

      <CustomModal
        isOpen={showLengthLimitModal}
        onCancel={() => setShowLengthLimitModal(false)}
        onConfirm={() => setShowLengthLimitModal(false)}
        title="Length Limit Reached"
        message={lengthLimitMessage}
        confirmText="OK"
        showCancel={false}
      />

      <QuoteDetailsModal
        isOpen={showQuoteDetailsModal}
        onClose={() => setShowQuoteDetailsModal(false)}
        quoteDetails={quoteDetails}
        setQuoteDetails={setQuoteDetails}
      />

      <CreateSaw
        Update="Add New Saw"
        isOpen={showAddSaw}
        onClose={() => setShowAddSaw(false)}
        onSave={handleAddNewSaw}
      />

      <SpacerModal
        isOpen={showSpacerModal}
        onClose={() => setShowSpacerModal(false)}
        onConfirm={(value) => {
          const currentItems = isRotatedBox ? rightBoxItems : leftBoxItems;
          const currentLength = calculateTotalLength(currentItems);
          const spacerValue = parseInt(value) || 0;

          if (currentLength + spacerValue > LENGTH_LIMIT_MAX_FT) {
            const remaining = LENGTH_LIMIT_MAX_FT - currentLength;
            setLengthLimitMessage(
              <>
                Cannot add {spacerValue}ft spacer. Maximum length is {LENGTH_LIMIT_MAX_FT}ft.
                <br />
                Only <span className="text-red-600 font-bold">{remaining}</span>
                ft remaining!
              </>
            );
            setShowLengthLimitModal(true);
            return;
          }

          const validatedValue = validateLength(spacerValue);
          const spacerItem = {
            type: "option",
            // REMOVE THIS LINE: src: spacerImage,
            alt: `SP-${validatedValue}`,
            labels: [],
            width: validatedValue,
            height: "100%",
            fixedWidth: true,
          };

          const boxSetter = isRotatedBox ? setRightBoxItems : setLeftBoxItems;
          const lengthSetter = isRotatedBox
            ? setOutfeedLength
            : setInfeedLength;

          boxSetter((prev) => {
            const newItems = [...prev, spacerItem];
            const totalLength = calculateTotalLength(newItems);
            lengthSetter(validateLength(totalLength));
            return newItems;
          });
        }}
        initialValue={Math.min(
          LENGTH_LIMIT_MAX_FT -
            calculateTotalLength(isRotatedBox ? rightBoxItems : leftBoxItems),
          10
        )}
        maxValue={
          LENGTH_LIMIT_MAX_FT - calculateTotalLength(isRotatedBox ? rightBoxItems : leftBoxItems)
        }
      />
    </div>
  );
};

export default Update;